import store from "@/store";
import { changeFloorSrd, changeFloorSrdC } from "@/utils/rlModuleUtils";
import { McGePoint3d, McDbLine, MxCpp, McObject } from "mxcad";
import {
  MovePt,
  isParallel,
  isPointEqual,
} from "@/rlMxModules/operate/structural";
import {
  ptOnLine,
  saveDatabaseStore,
  addEntityToDrawing,
  getEntityData,
  lineInsection,
} from "@/rlMxModules/operate/operateApi";
// 弹窗组件
import { VXETable } from "vxe-table";
import {
  rlJointData,
  rlGridData,
  rlJointCData,
  rlGridCData,
} from "@/rlMxModules/rlDataClass/index";
import oneMessage from "@/utils/oneMessage.js";
import { transferLocalData } from "@/utils/indexedDBModule/saveAllModules.js";
import { resetRlModulesBatch } from "@/mixins/LiteModuleDb.js";
import { baseURL } from "@/utils/request";
import axios from "axios";
import { projectConfig, configEdit } from "@/api/project";
// 全局loading
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import { getLocalUrlAndroid } from "@/api/androidApi";
import { map } from "xe-utils";
import Item from "@/layout/components/Sidebar/Item.vue";

let allMainModelData = {};

//草图/正图构件显示控制,仅2维显隐
export const showSketchData = async () => {
  await getMainModelData();
  let rl_floor_arr = store.state.globalData.rl_floor_arr;
  let rl_stdFlr_id = store.state.globalData.rl_stdFlr_id;
  const floorId = rl_floor_arr.find((item) => item.StdFlrGuid === rl_stdFlr_id);
  //切换前先保存
  await new Promise((resolve) => setTimeout(resolve, 200));
  await transferLocalData(
    store.state.cadModules.rlProject_id,
    "modelingData",
    1
  );
  if (floorId) {
    if (store.state.globalData.isSketch) {
      if (
        store.state.inspectionStore.backgroundImageIdShow &&
        store.state.inspectionStore.backgroundImageId
      ) {
        store.state.inspectionStore.backgroundImageId.getMcDbEntity().visible = true;
      } else {
        const { data } = await projectConfig({
          project_id: store.state.cadModules.rlProject_id,
        });
        if (data.model_config && data.model_config.image_path) {
          const mxcad = MxCpp.getCurrentMxCAD();
          mxcad.loadImage(data.model_config.image_path, async (image) => {
            if (!image) {
              return;
            }
            if (store.state.inspectionStore.backgroundImageId) {
              store.state.inspectionStore.backgroundImageId
                .getMcDbEntity()
                .erase();
            }
            let angle = data.model_config.angle || 0;
            let X = 0;
            let Y = 0;
            let tmpnum =
              data.model_config.image_width - data.model_config.image_height;
            let num = Math.abs(
              data.model_config.image_width - data.model_config.image_height
            );
            if (angle == 90) {
              if (tmpnum > 0) {
                X = data.model_config.image_width - num;
              } else {
                X = data.model_config.image_width + num;
              }
              Y = 0;
            } else if (angle == 180) {
              X = data.model_config.image_width;
              Y = data.model_config.image_height;
            } else if (angle == 270) {
              X = 0;
              if (tmpnum > 0) {
                Y = data.model_config.image_height + num;
              } else {
                Y = data.model_config.image_height - num;
              }
            }
            let idImage = mxcad.drawImage(
              X,
              Y,
              data.model_config.image_width,
              data.model_config.image_height,
              angle,
              data.model_config.image_path,
              true,
              data.model_config.image_width,
              data.model_config.image_height
            );
            if (idImage) {
              idImage.getMcDbEntity().drawOrder = 1; //设置显示优先级
              idImage.getMcDbEntity().visible = false;
              store.commit("inspectionStore/setbackgroundImageId", idImage);
            }
            mxcad.updateDisplay();
          });
        }
        if (data.model_config) {
          if (data.model_config.hasOwnProperty("isRoundSketch"))
            store.commit(
              "inspectionStore/setIsRoundSketch",
              data.model_config.isRoundSketch
            );
          if (data.model_config.hasOwnProperty("isAddWallThicknessSketch"))
            store.commit(
              "inspectionStore/setIsAddWallThicknessSketch",
              data.model_config.isAddWallThicknessSketch
            );
          if (data.model_config.hasOwnProperty("wallThicknessValueSketch"))
            store.commit(
              "inspectionStore/setWallThicknessValueSketch",
              data.model_config.wallThicknessValueSketch
            );
        }
      }
      changeFloorSrdC(floorId);
    } else {
      if (store.state.inspectionStore.backgroundImageId) {
        store.state.inspectionStore.backgroundImageId.getMcDbEntity().visible = false;
      }
      changeFloorSrd(floorId);
    }
  }
};

//背景显隐
export const backgroundShow = async () => {
  store.commit(
    "inspectionStore/setbackgroundImageIdShow",
    !store.state.inspectionStore.backgroundImageIdShow
  );
  if (store.state.inspectionStore.backgroundImageId) {
    let idImage = store.state.inspectionStore.backgroundImageId.getMcDbEntity();
    if (!idImage.visible) {
      const { data } = await projectConfig({
        project_id: store.state.cadModules.rlProject_id,
      });
      let width = 10000;
      let height = 10000;
      if (data.model_config) {
        width = data.model_config.image_width || 10000;
        height = data.model_config.image_height || 10000;
      }
      rlAppObj.mxcadObject.zoomW(
        new McGePoint3d(-3000, -3000),
        new McGePoint3d(width + 3000, height + 3000)
      );
    }
    idImage.visible = !idImage.visible;
  }
};

//清空正图数据
export const clearRegularizedData = async () => {
  await resetRlModulesBatch("rlGrid", store.state.globalData.rl_stdFlr_id, []);
  await resetRlModulesBatch("rlJoint", store.state.globalData.rl_stdFlr_id, []);
  await resetRlModulesBatch("rlAxis", store.state.globalData.rl_stdFlr_id, []);
  let allWallSeg = store.state.rlEntData.totalEntityData["rlWallSeg"];
  let allColSeg = store.state.rlEntData.totalEntityData["rlColSeg"];
  let allBeamSeg = store.state.rlEntData.totalEntityData["rlBeamSeg"];
  let allPartitionWallSeg =
    store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
  let saveWall = []; //保留的墙
  for (let i = 0; i < allWallSeg.length; i++) {
    if (
      getEntityData({
        classTypeName: "rlGridC",
        Guid: allWallSeg[i].m_gridData.Guid,
      })
    ) {
      saveWall.push({ objectId: allWallSeg[i].Guid, object: allWallSeg[i] });
    }
  }
  await resetRlModulesBatch(
    "rlWallSeg",
    store.state.globalData.rl_stdFlr_id,
    saveWall
  );
  let saveColSeg = [];
  for (let i = 0; i < allColSeg.length; i++) {
    if (
      getEntityData({
        classTypeName: "rlJointC",
        Guid: allColSeg[i].m_JointData.Guid,
      })
    ) {
      saveColSeg.push({ objectId: allColSeg[i].Guid, object: allColSeg[i] });
    }
  }
  await resetRlModulesBatch(
    "rlColSeg",
    store.state.globalData.rl_stdFlr_id,
    saveColSeg
  );
  let saveBeamSeg = [];
  for (let i = 0; i < allBeamSeg.length; i++) {
    if (
      getEntityData({
        classTypeName: "rlGridC",
        Guid: allBeamSeg[i].m_gridData.Guid,
      })
    ) {
      saveBeamSeg.push({ objectId: allBeamSeg[i].Guid, object: allBeamSeg[i] });
    }
  }
  await resetRlModulesBatch(
    "rlBeamSeg",
    store.state.globalData.rl_stdFlr_id,
    saveBeamSeg
  );
  // await resetRlModulesBatch("rlSlab", store.state.globalData.rl_stdFlr_id, []);
  // await resetRlModulesBatch(
  //   "rlSubBeam",
  //   store.state.globalData.rl_stdFlr_id,
  //   []
  // );
  // await resetRlModulesBatch(
  //   "rlRingBeamSeg",
  //   store.state.globalData.rl_stdFlr_id,
  //   []
  // );
  let savePartitionWallSeg = [];
  for (let i = 0; i < allPartitionWallSeg.length; i++) {
    if (
      allPartitionWallSeg[i].m_gridData &&
      getEntityData({
        classTypeName: "rlGridC",
        Guid: allPartitionWallSeg[i].m_gridData.Guid,
      })
    ) {
      savePartitionWallSeg.push({
        objectId: allPartitionWallSeg[i].Guid,
        object: allPartitionWallSeg[i],
      });
    }
  }
  await resetRlModulesBatch(
    "rlPartitionWallSeg",
    store.state.globalData.rl_stdFlr_id,
    savePartitionWallSeg
  );
  // await resetRlModulesBatch(
  //   "rlDoorsWindows",
  //   store.state.globalData.rl_stdFlr_id,
  //   []
  // );
  await resetRlModulesBatch("rlUse", store.state.globalData.rl_stdFlr_id, []);
  // await resetRlModulesBatch(
  //   "rlWallHole",
  //   store.state.globalData.rl_stdFlr_id,
  //   []
  // );
  // await resetRlModulesBatch(
  //   "rlSlabHole",
  //   store.state.globalData.rl_stdFlr_id,
  //   []
  // );
};

//清空草图数据
export const clearSketchData = async () => {
  let allJointC = store.state.rlEntData.totalEntityData["rlJointC"];
  let allGridC = store.state.rlEntData.totalEntityData["rlGridC"];
  let allJoint = allMainModelData.rlJoint;
  let allGrid = allMainModelData.rlGrid;
  // for (let i = 0; i < allJointC.length; i++) {
  //   if (!allJoint.find((item) => item.Guid === allJointC[i].Guid)) {
  //     console.log("allJointC[i].Guid", allJointC[i].Guid);

  //     allJointC[i].erase();
  //   }
  // }
  let eraseGridC = [];
  for (let i = 0; i < allGridC.length; i++) {
    let findGrid = allGrid.find((item) => item.Guid === allGridC[i].Guid);
    if (!findGrid) {
      eraseGridC.push(allGridC[i].Guid);
    } else {
      let stJointGuid = allGridC[i].m_stJoint.Guid;
      let edJointGuid = allGridC[i].m_edJoint.Guid;
      let originStJointGuid = findGrid.m_stJoint.Guid;
      let originEdJointGuid = findGrid.m_edJoint.Guid;
      if (
        stJointGuid !== originStJointGuid ||
        edJointGuid !== originEdJointGuid
      ) {
        eraseGridC.push(allGridC[i].Guid);
      }
    }
  }
  for (let i = 0; i < eraseGridC.length; i++) {
    let gridC = getEntityData({
      classTypeName: "rlGridC",
      Guid: eraseGridC[i],
    });
    if (gridC) {
      gridC.erase();
    }
  }
  // await resetRlModulesBatch("rlGridC", store.state.globalData.rl_stdFlr_id, []);
  // await resetRlModulesBatch(
  //   "rlJointC",
  //   store.state.globalData.rl_stdFlr_id,
  //   []
  // );
};

/**
 *
 * @param {*} lgnoreTipsGroup 忽略尺寸错误也可转正图
 * @returns
 */
//网格转正
export const sketchToRegularized = async (lgnoreTipsGroup = false) => {
  //删除没有用的线段
  await deleteNoUseLine();
  let gridCDistGroup = getSketchLineGroup();
  console.log("gridCDistGroup", gridCDistGroup);
  let { errorGridC, setLengthNum } = await checkSketchLength(gridCDistGroup); //获取所有长度错误网格
  if (setLengthNum > 0) {
    while (setLengthNum > 0) {
      gridCDistGroup = [];
      gridCDistGroup = getSketchLineGroup();
      ({ errorGridC, setLengthNum } = await checkSketchLength(gridCDistGroup)); //获取所有长度错误网格
    }
  }
  gridCDistGroup = [];
  gridCDistGroup = getSketchLineGroup();
  let tipsGroup = checkInputDataLength(gridCDistGroup); //获取所有长度错误网格
  let errorDatas = filterRepeatErrorLine(errorGridC, tipsGroup);
  if (errorDatas.errorGridC.length != 0 || errorDatas.tipsGroup.length != 0) {
    if (errorDatas.errorGridC.length == 0 && lgnoreTipsGroup) {
    } else {
      oneMessage.warning("请检查草图线的长度是否正确");
      //打开草图线错误检查弹窗
      store.commit("inspectionStore/setsketchChangeErrorData", errorDatas);
      store.commit("inspectionStore/setsketchChangeErrorShow", true);
      return;
    }
  }
  console.log("gridCDistGroup", gridCDistGroup);
  let datas = setSketchLineLength(gridCDistGroup);
  console.log("datas", datas);
  let { datasXGroup, datasYGroup, datasObliqueGroup } =
    getSketchLineGroupByAxis(datas);
  console.log("1111datasXGroup", datasXGroup);
  console.log("1111datasYGroup", datasYGroup);
  console.log("1111datasObliqueGroup", datasObliqueGroup);
  const type = await VXETable.modal.confirm(
    "草图转正图之后,正图的所有模型数据将被清空,而且无法恢复,是否继续?"
  );
  if (type == "confirm") {
    await clearRegularizedData();
  } else {
    return;
  }
  //创建网格
  await createGrid(datasXGroup, datasYGroup, datasObliqueGroup);
};

//添加背景图
export const addBackground = async () => {
  // const mxcad = MxCpp.getCurrentMxCAD();
  // //图片插入点
  // const pt = new McGePoint3d(0, 0, 0);
  // //图片地址
  // let imagUrl =
  //   "https://cdn.pixabay.com/photo/2022/11/15/12/23/winter-7593872_960_720.jpg";
  // mxcad.loadImage(imagUrl, (image) => {
  //   if (!image) {
  //     console.log("loadImage failed");
  //     return;
  //   }
  //   let width = mxcad.mxdraw.viewCoordLong2Cad(100);
  //   let height = (image.height / image.width) * width;
  //   mxcad.drawImage(
  //     0,
  //     0,
  //     width,
  //     height,
  //     0,
  //     imagUrl,
  //     true,
  //     image.width,
  //     image.height
  //   );
  //   mxcad.updateDisplay();
  // });

  selectImage()
    .then(async (result) => {
      const mxcad = MxCpp.getCurrentMxCAD();
      let appUrl = await getLocalUrlAndroid();
      let strUrl = `${
        store.state.app.isAndroid
          ? appUrl || "http://127.0.0.1:13244"
          : `${baseURL}`
      }/common/upload`;
      // 发送上传请求
      const formData = new FormData();
      formData.append("file", new Blob([result.binaryData]), result.name);

      const { data } = await axios.post(strUrl, formData, {
        headers: {
          token: store.state.user.token,
        },
      });
      if (data.code == 200) {
        let path = data.data.url;
        mxcad.loadImage(path, async (image) => {
          if (!image) {
            console.log("loadImage failed");
            return;
          }
          let width = 30000;
          let height = (image.height / image.width) * width;
          if (store.state.inspectionStore.backgroundImageId) {
            store.state.inspectionStore.backgroundImageId
              .getMcDbEntity()
              .erase();
          }
          let idImage = mxcad.drawImage(
            0,
            0,
            width,
            height,
            0,
            path,
            true,
            image.width,
            image.height
          );
          if (idImage) {
            idImage.getMcDbEntity().drawOrder = 1; //设置显示优先级
            store.commit("inspectionStore/setbackgroundImageId", idImage);
            const { data } = await projectConfig({
              project_id: store.state.cadModules.rlProject_id,
            });
            if (data.model_config) {
              data.model_config.image_path = path;
              data.model_config.image_width = width;
              data.model_config.image_height = height;
              data.model_config.angle = 0;
            } else {
              data.model_config = {
                image_path: path,
                image_width: width,
                image_height: height,
                angle: 0,
              };
            }
            //更新项目配置
            await configEdit({
              project_id: store.state.cadModules.rlProject_id,
              direction: data.direction,
              planar: data.planar,
              model_config: data.model_config,
            });
            rlAppObj.mxcadObject.zoomW(
              new McGePoint3d(-3000, -3000),
              new McGePoint3d(width + 3000, height + 3000)
            );
          }
          mxcad.updateDisplay();
        });
      }

      // const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      // getPoint.setInputToucheType(1);
      // oneMessage.info("请在图纸上点击选择插入点");
      // getPoint.go(async (status1) => {
      //   const pt = getPoint.value();

      // });
    })
    .catch((error) => {
      console.error("选择图片失败:", error);
    });
};

//选择图片
export const selectImage = async () => {
  //打开一个文件管理器选择图片
  return new Promise((resolve, reject) => {
    // 创建一个隐藏的文件输入框
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*"; // 仅接受图片文件
    fileInput.style.display = "none";
    document.body.appendChild(fileInput);

    // 文件选择监听
    fileInput.onchange = (event) => {
      const file = event.target.files[0];
      if (!file) {
        document.body.removeChild(fileInput);
        reject(new Error("未选择文件"));
        return;
      }

      // 检查文件类型
      if (!file.type.startsWith("image/")) {
        oneMessage.warning("请选择图片文件");
        document.body.removeChild(fileInput);
        reject(new Error("文件类型错误，请选择图片文件"));
        return;
      }

      // 检查文件大小（限制为10MB）
      if (file.size > 10 * 1024 * 1024) {
        oneMessage.warning("图片大小不能超过10MB");
        document.body.removeChild(fileInput);
        reject(new Error("文件过大"));
        return;
      }

      // 读取文件为Base64格式
      const reader = new FileReader();

      // 读取为二进制数据
      const readerBinary = new FileReader();

      reader.onload = (e) => {
        const imgData = e.target.result;

        // 读取二进制数据
        readerBinary.onload = (binaryEvent) => {
          const binaryData = binaryEvent.target.result;

          // 在这里处理图片，如添加到CAD背景等
          oneMessage.success("图片读取成功");

          // 清理DOM
          document.body.removeChild(fileInput);

          // 成功返回图片数据、路径和二进制数据
          resolve({
            name: file.name,
            type: file.type,
            size: file.size,
            path: fileInput.value, // 文件路径（注意：由于安全限制，这可能只是文件名）
            data: imgData, // Base64数据
            binaryData: binaryData, // 二进制数据
          });
        };

        readerBinary.onerror = () => {
          oneMessage.error("读取二进制文件失败");
          document.body.removeChild(fileInput);
          reject(new Error("读取二进制文件失败"));
        };

        // 开始读取二进制数据
        readerBinary.readAsArrayBuffer(file);
      };

      reader.onerror = () => {
        oneMessage.error("读取文件失败");
        document.body.removeChild(fileInput);
        reject(new Error("读取文件失败"));
      };

      // 开始读取Base64数据
      reader.readAsDataURL(file);
    };

    // 触发文件选择框
    fileInput.click();
  });
};
//创建网格
export const createGrid = async (
  datasXGroup,
  datasYGroup,
  datasObliqueGroup
) => {
  // 切换到正图
  store.commit("globalData/setIsSketch", false);
  showSketchData();
  //获取左下角的点
  let leftBottomPt = new McGePoint3d(-10000000, -10000000, 0);
  let ptX1 = MovePt(leftBottomPt, new THREE.Vector3(1, 0, 0), 1000000);
  let ptX2 = MovePt(leftBottomPt, new THREE.Vector3(1, 0, 0), -1000000);
  let ptY1 = MovePt(leftBottomPt, new THREE.Vector3(0, 1, 0), 1000000);
  let ptY2 = MovePt(leftBottomPt, new THREE.Vector3(0, 1, 0), -1000000);
  let lineY = new McDbLine();
  lineY.startPoint = ptY1;
  lineY.endPoint = ptY2;
  let lineX = new McDbLine();
  lineX.startPoint = ptX1;
  lineX.endPoint = ptX2;
  let datasX = [];
  let datasY = [];
  let datasOblique = [];
  let newJointData = []; //新创建的节点

  const createJoint = async (joint, pt, saveNewPt = false) => {
    let jointGuid = newJointData.find((item) => item == joint.Guid);
    let newJoint = null;
    if (!jointGuid) {
      newJoint = new rlJointData();
      newJoint.initData({
        m_pt: [pt.x, pt.y, pt.z],
        Guid: joint.Guid,
      });
      await addEntityToDrawing(newJoint, false);
      newJointData.push(newJoint.Guid);
    } else {
      newJoint = getEntityData({
        classTypeName: "rlJoint",
        Guid: jointGuid,
      });
      if (newJoint && saveNewPt) {
        newJoint.saveEditRevokeData();
        newJoint.m_pt = [pt.x, pt.y, pt.z];
        newJoint.updateThisObj(newJoint);
        saveDatabaseStore();
      }
    }
    return newJoint;
  };

  let allXGroup = [];
  for (let i = 0; i < datasXGroup.length; i++) {
    let group = datasXGroup[i];
    for (let j = 0; j < group.length; j++) {
      let item = group[j];
      allXGroup.push(item);
    }
  }

  //Y轴平行
  let newYGrideGroup = [];
  let newXGrideGroup = [];
  let jointDataGroup = []; //所有已转正的节点

  datasYGroup.sort((a, b) => {
    return a[0].gridC.m_stJoint.m_pt[0] - b[0].gridC.m_stJoint.m_pt[0];
  });

  for (let i = 0; i < datasYGroup.length; i++) {
    let group = datasYGroup[i];

    //当前段所有的网格节点
    let nowYJointGroup = [];
    for (let j = 0; j < group.length; j++) {
      let item = group[j].gridC;
      nowYJointGroup.push(item.m_stJoint);
      nowYJointGroup.push(item.m_edJoint);
    }
    let setX = -9999999999;
    //获取当前Y段需要偏移的X值
    for (let j = 0; j < nowYJointGroup.length; j++) {
      let item = nowYJointGroup[j];
      let findJoint = jointDataGroup.find((item1) => item1.Guid == item.Guid);
      if (findJoint) {
        if (findJoint.m_pt[0] > setX) {
          setX = findJoint.m_pt[0];
        }
      }
    }

    //判断首尾网格离X轴的距离
    if (group.length > 1) {
      let line1CenterPt = getLineCenterPt(group[0].gridC);
      let line2CenterPt = getLineCenterPt(group[group.length - 1].gridC);
      let dist1 = lineX
        .getClosestPointTo(line1CenterPt)
        .val.distanceTo(line1CenterPt);
      let dist2 = lineX
        .getClosestPointTo(line2CenterPt)
        .val.distanceTo(line2CenterPt);
      if (dist1 > dist2) {
        //逆序
        group = group.reverse();
      }
    }
    let nowYAllJoint = []; //当前段所有节点
    for (let j = 0; j < group.length; j++) {
      let item = group[j].gridC;
      let Length = group[j].Length;
      let stPt = new McGePoint3d(...item.m_stJoint.m_pt);
      let edPt = new McGePoint3d(...item.m_edJoint.m_pt);
      let stJoint = item.m_stJoint;
      let edJoint = item.m_edJoint;
      let dist1 = lineX.getClosestPointTo(stPt).val.distanceTo(stPt);
      let dist2 = lineX.getClosestPointTo(edPt).val.distanceTo(edPt);
      //用靠近X轴的点作为起点
      if (dist1 > dist2) {
        [stPt, edPt] = [edPt, stPt];
        [stJoint, edJoint] = [edJoint, stJoint];
      }
      //查找节点
      //修改末点位置
      let isChangeStart = !newJointData.includes(stJoint.Guid);
      let isChangeEnd = !newJointData.includes(edJoint.Guid);

      //如果当前段需要偏移X值,则更新起点和终点
      if (setX != -9999999999) {
        stPt.x = setX;
        edPt.x = setX;
      }
      //当布置第一个网格时,需要定位,与上一段中最下方的那个节点对比,查找偏移量
      if (j == 0) {
        //当前段第一个网格节点,最底下那个
        let indexTemp = -1;
        let beforeFirstJoint = null; //当前段从下往上第一个与X轴平行线相交的点
        //查找当前段中与上一段最下方的节点的网格索引
        for (let t = 0; t < group.length; t++) {
          let itTemp = group[t];
          let tempSt = new McGePoint3d(...itTemp.gridC.m_stJoint.m_pt);
          let tempEd = new McGePoint3d(...itTemp.gridC.m_edJoint.m_pt);
          for (let y = 0; y < jointDataGroup.length; y++) {
            if (
              itTemp.gridC.m_stJoint.Guid == jointDataGroup[y].Guid &&
              tempEd.y < tempSt.y
            ) {
              beforeFirstJoint = jointDataGroup[y];
              indexTemp = t;
              break;
            } else if (
              itTemp.gridC.m_edJoint.Guid == jointDataGroup[y].Guid &&
              tempSt.y < tempEd.y
            ) {
              beforeFirstJoint = jointDataGroup[y];
              indexTemp = t;
              break;
            }
          }
          if (indexTemp != -1) break;
        }
        if (indexTemp != -1) {
          let dist = 0;
          //计算偏移量
          for (let t = 0; t <= indexTemp; t++) {
            dist += group[t].Length;
          }
          // console.log("group.........", group, i);

          // console.log("偏移量:", dist);
          let ptStTemp = new McGePoint3d(...beforeFirstJoint.m_pt);
          // console.log("ptStTemp.y.before", ptStTemp.y);
          stPt.y = ptStTemp.y - dist;
          // console.log("stPt.y.after", stPt.y);
        }
      }

      let newStJoint = await createJoint(stJoint, stPt, isChangeStart);
      if (newStJoint) {
        stPt = new McGePoint3d(...newStJoint.m_pt);
        edPt = MovePt(stPt, new THREE.Vector3(0, 1, 0), Length);
      }
      let newEdJoint = await createJoint(edJoint, edPt, isChangeEnd);
      let findJoint = null;
      if (newStJoint) {
        findJoint = jointDataGroup.find(
          (item1) => item1.Guid == newStJoint.Guid
        );
        if (!findJoint) {
          jointDataGroup.push(newStJoint);
        }
        findJoint = nowYAllJoint.find((item1) => item1.Guid == newStJoint.Guid);
        if (!findJoint) {
          nowYAllJoint.push(newStJoint);
        }
      }
      if (newEdJoint) {
        findJoint = jointDataGroup.find(
          (item1) => item1.Guid == newEdJoint.Guid
        );
        if (!findJoint) {
          jointDataGroup.push(newEdJoint);
        }
        findJoint = nowYAllJoint.find((item1) => item1.Guid == newEdJoint.Guid);
        if (!findJoint) {
          nowYAllJoint.push(newEdJoint);
        }
      }
      if (newStJoint && newEdJoint) {
        let newGrid = new rlGridData();
        newGrid.initData({
          m_stJoint: newStJoint,
          m_edJoint: newEdJoint,
          Guid: item.Guid,
          m_Axis: null,
        });
        await addEntityToDrawing(newGrid, false);
        newYGrideGroup.push({ newGrid, Length: Length });
      }
    }
    //把与当前段Y轴平行的X轴网格创建
    let deleteXGroup = [];
    let tempSaveXGridJoint = [];
    for (let j = 0; j < allXGroup.length; j++) {
      if (allXGroup[j].Length == 0) continue;
      let gridX = allXGroup[j].gridC;
      let newStJoint = nowYAllJoint.find(
        (item1) => item1.Guid == gridX.m_stJoint.Guid
      );
      let newEdJoint = nowYAllJoint.find(
        (item1) => item1.Guid == gridX.m_edJoint.Guid
      );
      if (newStJoint) {
        let ptSt = new McGePoint3d(...newStJoint.m_pt);
        let ptEd = null;
        // ptEd = MovePt(ptSt, new THREE.Vector3(1, 0, 0), allXGroup[j].Length);

        if (gridX.m_stJoint.m_pt[0] < gridX.m_edJoint.m_pt[0]) {
          ptEd = MovePt(ptSt, new THREE.Vector3(1, 0, 0), allXGroup[j].Length);
        } else {
          ptEd = MovePt(ptSt, new THREE.Vector3(-1, 0, 0), allXGroup[j].Length);
        }

        let newEdJoint1 = await createJoint(gridX.m_edJoint, ptEd);
        let findJoint = jointDataGroup.find(
          (item1) => item1.Guid == newEdJoint1.Guid
        );
        if (!findJoint) {
          jointDataGroup.push(newEdJoint1);
        }
        let newGrid = new rlGridData();
        newGrid.initData({
          m_stJoint: newStJoint,
          m_edJoint: newEdJoint1,
          Guid: gridX.Guid,
          m_Axis: null,
        });
        await addEntityToDrawing(newGrid, false);
        newXGrideGroup.push({ newGrid, Length: allXGroup[j].Length });
        deleteXGroup.push(allXGroup[j]);
        tempSaveXGridJoint.push(newEdJoint1);
      } else if (newEdJoint) {
        let ptEd = new McGePoint3d(...newEdJoint.m_pt);
        let ptSt = null;
        // ptSt = MovePt(ptEd, new THREE.Vector3(1, 0, 0), allXGroup[j].Length);
        if (gridX.m_edJoint.m_pt[0] < gridX.m_stJoint.m_pt[0]) {
          ptSt = MovePt(ptEd, new THREE.Vector3(1, 0, 0), allXGroup[j].Length);
        } else {
          ptSt = MovePt(ptEd, new THREE.Vector3(-1, 0, 0), allXGroup[j].Length);
        }
        let newStJoint1 = await createJoint(gridX.m_stJoint, ptSt);
        let findJoint = jointDataGroup.find(
          (item1) => item1.Guid == newStJoint1.Guid
        );
        if (!findJoint) {
          jointDataGroup.push(newStJoint1);
        }
        let newGrid = new rlGridData();
        newGrid.initData({
          m_stJoint: newEdJoint,
          m_edJoint: newStJoint1,
          Guid: gridX.Guid,
          m_Axis: null,
        });
        await addEntityToDrawing(newGrid, false);
        newXGrideGroup.push({ newGrid, Length: allXGroup[j].Length });
        deleteXGroup.push(allXGroup[j]);
        tempSaveXGridJoint.push(newStJoint1);
      }
    }
    //再循环
    while (tempSaveXGridJoint.length > 0) {
      let copyTempSaveXGridJoint = tempSaveXGridJoint.slice();
      tempSaveXGridJoint = [];
      for (let j = 0; j < allXGroup.length; j++) {
        if (allXGroup[j].Length == 0) continue;
        let finddelIndex = deleteXGroup.findIndex(
          (item) => item.gridC.Guid == allXGroup[j].gridC.Guid
        );
        if (finddelIndex !== -1) {
          continue;
        }

        let gridX = allXGroup[j].gridC;
        let newStJoint = copyTempSaveXGridJoint.find(
          (item1) => item1.Guid == gridX.m_stJoint.Guid
        );
        let newEdJoint = copyTempSaveXGridJoint.find(
          (item1) => item1.Guid == gridX.m_edJoint.Guid
        );
        if (newStJoint && gridX.m_stJoint.m_gridIds.length == 2) {
          let ptSt = new McGePoint3d(...newStJoint.m_pt);
          let ptEd = MovePt(
            ptSt,
            new THREE.Vector3(1, 0, 0),
            allXGroup[j].Length
          );
          let newEdJoint1 = await createJoint(gridX.m_edJoint, ptEd);
          let findJoint = jointDataGroup.find(
            (item1) => item1.Guid == newEdJoint1.Guid
          );
          if (!findJoint) {
            jointDataGroup.push(newEdJoint1);
          }
          let newGrid = new rlGridData();
          newGrid.initData({
            m_stJoint: newStJoint,
            m_edJoint: newEdJoint1,
            Guid: gridX.Guid,
            m_Axis: null,
          });
          await addEntityToDrawing(newGrid, false);
          newXGrideGroup.push({ newGrid, Length: allXGroup[j].Length });
          deleteXGroup.push(allXGroup[j]);
          tempSaveXGridJoint.push(newEdJoint1);
        } else if (newEdJoint && gridX.m_edJoint.m_gridIds.length == 2) {
          let ptEd = new McGePoint3d(...newEdJoint.m_pt);
          let ptSt = (ptSt = MovePt(
            ptEd,
            new THREE.Vector3(1, 0, 0),
            allXGroup[j].Length
          ));
          let newStJoint1 = await createJoint(gridX.m_stJoint, ptSt);
          let findJoint = jointDataGroup.find(
            (item1) => item1.Guid == newStJoint1.Guid
          );
          if (!findJoint) {
            jointDataGroup.push(newStJoint1);
          }
          let newGrid = new rlGridData();
          newGrid.initData({
            m_stJoint: newEdJoint,
            m_edJoint: newStJoint1,
            Guid: gridX.Guid,
            m_Axis: null,
          });
          await addEntityToDrawing(newGrid, false);
          newXGrideGroup.push({ newGrid, Length: allXGroup[j].Length });
          deleteXGroup.push(allXGroup[j]);
          tempSaveXGridJoint.push(newStJoint1);
        }
      }
    }
    for (let j = 0; j < deleteXGroup.length; j++) {
      let findIndex = allXGroup.findIndex(
        (item) => item.gridC.Guid == deleteXGroup[j].gridC.Guid
      );
      if (findIndex != -1) {
        allXGroup.splice(findIndex, 1);
      }
    }

    // newYGrideGroup.push(tempNewYGrideGroup);
  }
  //处理与斜线相连的X轴网格
  if (allXGroup.length > 0) {
    let obliqueGroup = [];
    for (let i = 0; i < datasObliqueGroup.length; i++) {
      for (let j = 0; j < datasObliqueGroup[i].length; j++) {
        obliqueGroup.push(datasObliqueGroup[i][j].gridC);
      }
    }
    let XGroup = [];
    for (let i = 0; i < allXGroup.length; i++) {
      XGroup.push(allXGroup[i].gridC);
    }
    let connectedLines = getConnectedLines(obliqueGroup);
    for (let i = 0; i < connectedLines.length; i++) {
      let leftGrid = [];
      for (let j = 0; j < connectedLines[i].length; j++) {
        let stGrid = [];
        let edGrid = [];
        let stGridGroup = connectedLines[i][j].m_stJoint.m_gridIds;
        let edGridGroup = connectedLines[i][j].m_edJoint.m_gridIds;
        for (let d = 0; d < stGridGroup.length; d++) {
          let grid = getEntityData({
            Guid: stGridGroup[d],
            classTypeName: "rlGridC",
          });
          let st = new McGePoint3d(...grid.m_stJoint.m_pt);
          let ed = new McGePoint3d(...grid.m_edJoint.m_pt);
          if (
            isParallel(
              st,
              ed,
              new McGePoint3d(1000, 0, 0),
              new McGePoint3d(-1000, 0, 0)
            )
          ) {
            stGrid.push(grid);
          }
        }
        for (let d = 0; d < edGridGroup.length; d++) {
          let grid = getEntityData({
            Guid: edGridGroup[d],
            classTypeName: "rlGridC",
          });
          let st = new McGePoint3d(...grid.m_stJoint.m_pt);
          let ed = new McGePoint3d(...grid.m_edJoint.m_pt);
          if (
            isParallel(
              st,
              ed,
              new McGePoint3d(1000, 0, 0),
              new McGePoint3d(-1000, 0, 0)
            )
          ) {
            edGrid.push(grid);
          }
        }
        for (let s = 0; s < stGrid.length; s++) {
          if (stGrid[s].m_stJoint.Guid == connectedLines[i][j].m_stJoint.Guid) {
            if (stGrid[s].m_edJoint.m_pt[0] < stGrid[s].m_stJoint.m_pt[0]) {
              if (!leftGrid.find((item) => item.grid.Guid == stGrid[s].Guid)) {
                let jonit = getEntityData({
                  Guid: connectedLines[i][j].m_stJoint.Guid,
                  classTypeName: "rlJoint",
                });
                leftGrid.push({
                  grid: stGrid[s],
                  joint: jonit ? jonit : connectedLines[i][j].m_stJoint,
                  oblique: connectedLines[i][j],
                });
              }
            }
          }
          if (stGrid[s].m_edJoint.Guid == connectedLines[i][j].m_stJoint.Guid) {
            if (stGrid[s].m_stJoint.m_pt[0] < stGrid[s].m_edJoint.m_pt[0]) {
              if (!leftGrid.find((item) => item.grid.Guid == stGrid[s].Guid)) {
                let jonit = getEntityData({
                  Guid: connectedLines[i][j].m_stJoint.Guid,
                  classTypeName: "rlJoint",
                });
                leftGrid.push({
                  grid: stGrid[s],
                  joint: jonit ? jonit : connectedLines[i][j].m_stJoint,
                  oblique: connectedLines[i][j],
                });
              }
            }
          }
        }
        for (let s = 0; s < edGrid.length; s++) {
          if (edGrid[s].m_stJoint.Guid == connectedLines[i][j].m_edJoint.Guid) {
            if (edGrid[s].m_edJoint.m_pt[0] < edGrid[s].m_stJoint.m_pt[0]) {
              if (!leftGrid.find((item) => item.grid.Guid == edGrid[s].Guid)) {
                let jonit = getEntityData({
                  Guid: connectedLines[i][j].m_edJoint.Guid,
                  classTypeName: "rlJoint",
                });
                leftGrid.push({
                  grid: edGrid[s],
                  joint: jonit ? jonit : connectedLines[i][j].m_edJoint,
                  oblique: connectedLines[i][j],
                });
              }
            }
          }
          if (edGrid[s].m_edJoint.Guid == connectedLines[i][j].m_edJoint.Guid) {
            if (edGrid[s].m_stJoint.m_pt[0] < edGrid[s].m_edJoint.m_pt[0]) {
              if (!leftGrid.find((item) => item.grid.Guid == edGrid[s].Guid)) {
                let jonit = getEntityData({
                  Guid: connectedLines[i][j].m_edJoint.Guid,
                  classTypeName: "rlJoint",
                });
                leftGrid.push({
                  grid: edGrid[s],
                  joint: jonit ? jonit : connectedLines[i][j].m_edJoint,
                  oblique: connectedLines[i][j],
                });
              }
            }
          }
        }
      }
      if (leftGrid.length > 0) {
        leftGrid.sort(
          (a, b) => a.grid.m_stJoint.m_pt[1] - b.grid.m_stJoint.m_pt[1]
        );
        let containGroup = [];
        let tempGroup = [];
        for (let i = 0; i < leftGrid.length; i++) {
          if (leftGrid[i].grid.Length > 0 && tempGroup.length == 0) {
            tempGroup.push(leftGrid[i]);
          } else if (leftGrid[i].grid.Length == 0 && tempGroup.length > 0) {
            tempGroup.push(leftGrid[i]);
          } else if (leftGrid[i].grid.Length > 0 && tempGroup.length > 0) {
            tempGroup.push(leftGrid[i]);
            containGroup.push(tempGroup);
            tempGroup = [];
          }
        }
        for (let d = 0; d < containGroup.length; d++) {
          if (containGroup[d].length == 2) continue;
          if (!containGroup[d][0].joint || !containGroup[d][0].joint.m_pt)
            continue;
          let firstJoint = new McGePoint3d(...containGroup[d][0].joint.m_pt);
          let lastJoint = new McGePoint3d(
            ...containGroup[d][containGroup[d].length - 1].joint.m_pt
          );
          let vec1 = new THREE.Vector3()
            .subVectors(firstJoint, lastJoint)
            .normalize();
          let vec2 = new THREE.Vector3(-vec1.x, -vec1.y, 0);
          for (let k = 0; k < containGroup[d].length; k++) {
            if (k == containGroup[d].length - 1) {
              continue;
            }
            if (
              containGroup[d][k].oblique.m_stJoint.Guid ==
              containGroup[d][k].joint.Guid
            ) {
              let pt1 = new McGePoint3d(
                ...containGroup[d][k].oblique.m_stJoint.m_pt
              );
              let pt2 = MovePt(pt1, vec1, 1000000);
              let pt3 = MovePt(pt1, vec2, 1000000);
              let nextGrid = containGroup[d][k + 1].grid;
              let nextGridSt = new McGePoint3d(...nextGrid.m_stJoint.m_pt);
              nextGridSt = MovePt(
                nextGridSt,
                new THREE.Vector3(1, 0, 0),
                1000000
              );
              let nextGridEd = new McGePoint3d(...nextGrid.m_edJoint.m_pt);
              nextGridEd = MovePt(
                nextGridEd,
                new THREE.Vector3(-1, 0, 0),
                1000000
              );
              let res = lineInsection(pt2, pt3, nextGridSt, nextGridEd);
              // let line1 = new McDbLine(pt2.x, pt2.y, 0, pt3.x, pt3.y, 0);
              // let line2 = new McDbLine(
              //   nextGridSt.x,
              //   nextGridSt.y,
              //   0,
              //   nextGridEd.x,
              //   nextGridEd.y,
              //   0
              // );
              // rlAppObj.mxcadObject.drawEntity(line1);
              // rlAppObj.mxcadObject.drawEntity(line2);
              if (res.isIntersected) {
                let intersectPt = new McGePoint3d(
                  res.intersectionPoint.x,
                  res.intersectionPoint.y,
                  0
                );

                containGroup[d][k].oblique.m_edJoint.m_pt = [
                  intersectPt.x,
                  intersectPt.y,
                  0,
                ];
              }
            } else if (
              containGroup[d][k].oblique.m_edJoint.Guid ==
              containGroup[d][k].joint.Guid
            ) {
              let pt1 = new McGePoint3d(
                ...containGroup[d][k].oblique.m_edJoint.m_pt
              );
              let pt2 = MovePt(pt1, vec1, 1000000);
              let pt3 = MovePt(pt1, vec2, 1000000);
              let nextGrid = containGroup[d][k + 1].grid;
              let nextGridSt = new McGePoint3d(...nextGrid.m_stJoint.m_pt);
              nextGridSt = MovePt(
                nextGridSt,
                new THREE.Vector3(1, 0, 0),
                1000000
              );
              let nextGridEd = new McGePoint3d(...nextGrid.m_edJoint.m_pt);
              nextGridEd = MovePt(
                nextGridEd,
                new THREE.Vector3(-1, 0, 0),
                1000000
              );
              let res = lineInsection(pt2, pt3, nextGridSt, nextGridEd);
              // let line1 = new McDbLine(pt2.x, pt2.y, 0, pt3.x, pt3.y, 0);
              // let line2 = new McDbLine(
              //   nextGridSt.x,
              //   nextGridSt.y,
              //   0,
              //   nextGridEd.x,
              //   nextGridEd.y,
              //   0
              // );
              // rlAppObj.mxcadObject.drawEntity(line1);
              // rlAppObj.mxcadObject.drawEntity(line2);
              if (res.isIntersected) {
                let intersectPt = new McGePoint3d(
                  res.intersectionPoint.x,
                  res.intersectionPoint.y,
                  0
                );

                containGroup[d][k].oblique.m_stJoint.m_pt = [
                  intersectPt.x,
                  intersectPt.y,
                  0,
                ];
              }
            }
          }
        }
      }
    }
    let isDrawNew = false;
    while (true) {
      isDrawNew = false;
      for (let o = 0; o < obliqueGroup.length; o++) {
        let stGridGroup = obliqueGroup[o].m_stJoint.m_gridIds;
        let edGridGroup = obliqueGroup[o].m_edJoint.m_gridIds;
        let stGrid = [];
        let edGrid = [];
        for (let i = 0; i < stGridGroup.length; i++) {
          let grid = getEntityData({
            Guid: stGridGroup[i],
            classTypeName: "rlGridC",
          });
          let st = new McGePoint3d(...grid.m_stJoint.m_pt);
          let ed = new McGePoint3d(...grid.m_edJoint.m_pt);
          if (
            isParallel(
              st,
              ed,
              new McGePoint3d(1000, 0, 0),
              new McGePoint3d(-1000, 0, 0)
            )
          ) {
            stGrid.push(grid);
          }
        }
        for (let i = 0; i < edGridGroup.length; i++) {
          let grid = getEntityData({
            Guid: edGridGroup[i],
            classTypeName: "rlGridC",
          });
          let st = new McGePoint3d(...grid.m_stJoint.m_pt);
          let ed = new McGePoint3d(...grid.m_edJoint.m_pt);
          if (
            isParallel(
              st,
              ed,
              new McGePoint3d(1000, 0, 0),
              new McGePoint3d(-1000, 0, 0)
            )
          ) {
            edGrid.push(grid);
          }
        }
        // console.log("stGrid", stGrid);
        // console.log("edGrid", edGrid);
        if (stGrid && edGrid) {
          // 获取stGrid和edGrid的左端点
          let stLeftGrid = null;
          let edLeftGrid = null;
          for (let i = 0; i < stGrid.length; i++) {
            if (stGrid[i].m_stJoint.Guid == obliqueGroup[o].m_stJoint.Guid) {
              if (stGrid[i].m_edJoint.m_pt[0] < stGrid[i].m_stJoint.m_pt[0]) {
                stLeftGrid = stGrid[i];
              }
            }
            if (stGrid[i].m_edJoint.Guid == obliqueGroup[o].m_stJoint.Guid) {
              if (stGrid[i].m_stJoint.m_pt[0] < stGrid[i].m_edJoint.m_pt[0]) {
                stLeftGrid = stGrid[i];
              }
            }
          }
          for (let i = 0; i < edGrid.length; i++) {
            if (edGrid[i].m_stJoint.Guid == obliqueGroup[o].m_edJoint.Guid) {
              if (edGrid[i].m_edJoint.m_pt[0] < edGrid[i].m_stJoint.m_pt[0]) {
                edLeftGrid = edGrid[i];
              }
            }
            if (edGrid[i].m_edJoint.Guid == obliqueGroup[o].m_edJoint.Guid) {
              if (edGrid[i].m_stJoint.m_pt[0] < edGrid[i].m_edJoint.m_pt[0]) {
                edLeftGrid = edGrid[i];
              }
            }
          }
          // console.log("stLeftGrid", stLeftGrid);
          // console.log("edLeftGrid", edLeftGrid);
          if (
            stLeftGrid &&
            edLeftGrid &&
            ((stLeftGrid.Length == 0 && edLeftGrid.Length > 0) ||
              (stLeftGrid.Length > 0 && edLeftGrid.Length == 0))
          ) {
            let mainGrid = stLeftGrid.Length > 0 ? stLeftGrid : edLeftGrid;
            let childGrid = stLeftGrid.Length > 0 ? edLeftGrid : stLeftGrid;
            let stJoint = null;
            let vec1 = new THREE.Vector3()
              .subVectors(
                new THREE.Vector3(...obliqueGroup[o].m_stJoint.m_pt),
                new THREE.Vector3(...obliqueGroup[o].m_edJoint.m_pt)
              )
              .normalize();
            let vec2 = new THREE.Vector3(-vec1.x, -vec1.y, 0);
            if (mainGrid.m_stJoint.Guid == obliqueGroup[o].m_stJoint.Guid) {
              stJoint = mainGrid.m_stJoint;
            } else if (
              mainGrid.m_edJoint.Guid == obliqueGroup[o].m_stJoint.Guid
            ) {
              stJoint = mainGrid.m_edJoint;
            } else if (
              mainGrid.m_stJoint.Guid == obliqueGroup[o].m_edJoint.Guid
            ) {
              stJoint = mainGrid.m_stJoint;
            } else if (
              mainGrid.m_edJoint.Guid == obliqueGroup[o].m_edJoint.Guid
            ) {
              stJoint = mainGrid.m_edJoint;
            }
            if (stJoint && vec1 && vec2) {
              let newStJoint = jointDataGroup.find(
                (item1) => childGrid.m_stJoint.Guid == item1.Guid
              );
              let newEdJoint = jointDataGroup.find(
                (item1) => childGrid.m_edJoint.Guid == item1.Guid
              );
              let gridStPt = jointDataGroup.find(
                (item1) => stJoint.Guid == item1.Guid
              );
              let childGridSt = childGrid.m_stJoint;
              let childGridEd = childGrid.m_edJoint;
              if (!gridStPt) continue;
              if (!newStJoint && !newEdJoint) {
                continue;
              } else if (!newStJoint && newEdJoint) {
                [newStJoint, newEdJoint] = [newEdJoint, newStJoint];
                [childGridSt, childGridEd] = [childGridEd, childGridSt];
              } else if (newStJoint && newEdJoint) {
                let newGrid = new rlGridData();
                newGrid.initData({
                  m_stJoint: newStJoint,
                  m_edJoint: newEdJoint,
                  Guid: childGrid.Guid,
                  m_Axis: null,
                });
                await addEntityToDrawing(newGrid, false);
                isDrawNew = true;
                let pt3d1 = new McGePoint3d(...newStJoint.m_pt);
                let pt3d2 = new McGePoint3d(...newEdJoint.m_pt);
                let dist = pt3d1.distanceTo(pt3d2).toFixed(0);
                const childGridC = getEntityData({
                  Guid: childGrid.Guid,
                  classTypeName: "rlGridC",
                });
                childGridC.saveEditRevokeData();
                childGridC.Length = dist;
                childGridC.updateThisObj(childGridC);
              }

              let pt1 = new McGePoint3d(...newStJoint.m_pt);
              let pt2 = MovePt(pt1, new THREE.Vector3(1, 0, 0), 1000000);
              let pt3 = new McGePoint3d(...gridStPt.m_pt);
              let pt4 = MovePt(pt3, vec1, 1000000);
              let pt5 = MovePt(pt3, vec2, 1000000);
              let res = lineInsection(pt1, pt2, pt4, pt5);
              // console.log("pt1", pt1);
              // console.log("pt2", pt2);
              // console.log("pt3", pt3);
              // console.log("pt4", pt4);
              // let line1 = new McDbLine(pt1.x, pt1.y, 0, pt2.x, pt2.y, 0);
              // let line2 = new McDbLine(pt3.x, pt3.y, 0, pt4.x, pt4.y, 0);
              // rlAppObj.mxcadObject.drawEntity(line1);
              // rlAppObj.mxcadObject.drawEntity(line2);
              // console.log("res", res);
              if (res.isIntersected) {
                const intersectPt = new McGePoint3d(
                  res.intersectionPoint.x,
                  res.intersectionPoint.y,
                  0
                );
                let newEdJoint1 = await createJoint(childGridEd, intersectPt);
                let findJoint = jointDataGroup.find(
                  (item1) => item1.Guid == newEdJoint1.Guid
                );
                if (!findJoint) {
                  jointDataGroup.push(newEdJoint1);
                }
                let newGrid = new rlGridData();
                newGrid.initData({
                  m_stJoint: newStJoint,
                  m_edJoint: newEdJoint1,
                  Guid: childGrid.Guid,
                  m_Axis: null,
                });
                await addEntityToDrawing(newGrid, false);
                isDrawNew = true;

                let pt3d = new McGePoint3d(...newStJoint.m_pt);
                let dist = pt3d.distanceTo(intersectPt).toFixed(0);
                const childGridC = getEntityData({
                  Guid: childGrid.Guid,
                  classTypeName: "rlGridC",
                });
                childGridC.saveEditRevokeData();
                childGridC.Length = dist;
                childGridC.updateThisObj(childGridC);
              }
            }
          }
          //获取stGrid和edGrid的右端点
          let stRightGrid = null;
          let edRightGrid = null;
          for (let i = 0; i < stGrid.length; i++) {
            if (stGrid[i].m_stJoint.Guid == obliqueGroup[o].m_stJoint.Guid) {
              if (stGrid[i].m_edJoint.m_pt[0] > stGrid[i].m_stJoint.m_pt[0]) {
                stRightGrid = stGrid[i];
              }
            }
            if (stGrid[i].m_edJoint.Guid == obliqueGroup[o].m_stJoint.Guid) {
              if (stGrid[i].m_stJoint.m_pt[0] > stGrid[i].m_edJoint.m_pt[0]) {
                stRightGrid = stGrid[i];
              }
            }
          }
          for (let i = 0; i < edGrid.length; i++) {
            if (edGrid[i].m_stJoint.Guid == obliqueGroup[o].m_edJoint.Guid) {
              if (edGrid[i].m_edJoint.m_pt[0] > edGrid[i].m_stJoint.m_pt[0]) {
                edRightGrid = edGrid[i];
              }
            }
            if (edGrid[i].m_edJoint.Guid == obliqueGroup[o].m_edJoint.Guid) {
              if (edGrid[i].m_stJoint.m_pt[0] > edGrid[i].m_edJoint.m_pt[0]) {
                edRightGrid = edGrid[i];
              }
            }
          }
          // console.log("stRightGrid", stRightGrid);
          // console.log("edRightGrid", edRightGrid);

          if (
            stRightGrid &&
            edRightGrid &&
            ((stRightGrid.Length == 0 && edRightGrid.Length > 0) ||
              (stRightGrid.Length > 0 && edRightGrid.Length == 0))
          ) {
            let mainGrid = stRightGrid.Length > 0 ? stRightGrid : edRightGrid;
            let childGrid = stRightGrid.Length > 0 ? edRightGrid : stRightGrid;
            let stJoint = null;
            let vec1 = new THREE.Vector3()
              .subVectors(
                new THREE.Vector3(...obliqueGroup[o].m_edJoint.m_pt),
                new THREE.Vector3(...obliqueGroup[o].m_stJoint.m_pt)
              )
              .normalize();
            let vec2 = new THREE.Vector3(-vec1.x, -vec1.y, 0);
            if (mainGrid.m_stJoint.Guid == obliqueGroup[o].m_stJoint.Guid) {
              stJoint = mainGrid.m_stJoint;
            } else if (
              mainGrid.m_edJoint.Guid == obliqueGroup[o].m_stJoint.Guid
            ) {
              stJoint = mainGrid.m_edJoint;
            } else if (
              mainGrid.m_stJoint.Guid == obliqueGroup[o].m_edJoint.Guid
            ) {
              stJoint = mainGrid.m_stJoint;
            } else if (
              mainGrid.m_edJoint.Guid == obliqueGroup[o].m_edJoint.Guid
            ) {
              stJoint = mainGrid.m_edJoint;
            }
            // console.log("stJoint", stJoint);
            // console.log("vec", vec);

            if (stJoint && vec1 && vec2) {
              let newStJoint = jointDataGroup.find(
                (item1) => childGrid.m_stJoint.Guid == item1.Guid
              );
              let newEdJoint = jointDataGroup.find(
                (item1) => childGrid.m_edJoint.Guid == item1.Guid
              );
              let gridStPt = jointDataGroup.find(
                (item1) => stJoint.Guid == item1.Guid
              );
              let childGridSt = childGrid.m_stJoint;
              let childGridEd = childGrid.m_edJoint;
              if (!gridStPt) continue;
              if (!newStJoint && !newEdJoint) {
                continue;
              } else if (!newStJoint && newEdJoint) {
                [newStJoint, newEdJoint] = [newEdJoint, newStJoint];
                [childGridSt, childGridEd] = [childGridEd, childGridSt];
              } else if (newStJoint && newEdJoint) {
                let newGrid = new rlGridData();
                newGrid.initData({
                  m_stJoint: newStJoint,
                  m_edJoint: newEdJoint,
                  Guid: childGrid.Guid,
                  m_Axis: null,
                });
                await addEntityToDrawing(newGrid, false);
                isDrawNew = true;
                let pt3d1 = new McGePoint3d(...newStJoint.m_pt);
                let pt3d2 = new McGePoint3d(...newEdJoint.m_pt);
                let dist = pt3d1.distanceTo(pt3d2).toFixed(0);
                const childGridC = getEntityData({
                  Guid: childGrid.Guid,
                  classTypeName: "rlGridC",
                });
                childGridC.saveEditRevokeData();
                childGridC.Length = dist;
                childGridC.updateThisObj(childGridC);
              }
              let pt1 = new McGePoint3d(...newStJoint.m_pt);
              let pt2 = MovePt(pt1, new THREE.Vector3(-1, 0, 0), 1000000);
              let pt3 = new McGePoint3d(...gridStPt.m_pt);
              let pt4 = MovePt(pt3, vec1, 1000000);
              let pt5 = MovePt(pt3, vec2, 1000000);
              let res = lineInsection(pt1, pt2, pt4, pt5);
              // console.log("pt1", pt1);
              // console.log("pt2", pt2);
              // console.log("pt3", pt3);
              // console.log("pt4", pt4);
              // console.log("pt5", pt5);
              // let line1 = new McDbLine(pt1.x, pt1.y, 0, pt2.x, pt2.y, 0);
              // let line2 = new McDbLine(pt4.x, pt4.y, 0, pt5.x, pt5.y, 0);
              // rlAppObj.mxcadObject.drawEntity(line1);
              // rlAppObj.mxcadObject.drawEntity(line2);
              // console.log("res", res);
              if (res.isIntersected) {
                const intersectPt = new McGePoint3d(
                  res.intersectionPoint.x,
                  res.intersectionPoint.y,
                  0
                );
                let newEdJoint1 = await createJoint(childGridEd, intersectPt);
                let findJoint = jointDataGroup.find(
                  (item1) => item1.Guid == newEdJoint1.Guid
                );
                if (!findJoint) {
                  jointDataGroup.push(newEdJoint1);
                }
                let newGrid = new rlGridData();
                newGrid.initData({
                  m_stJoint: newStJoint,
                  m_edJoint: newEdJoint1,
                  Guid: childGrid.Guid,
                  m_Axis: null,
                });
                await addEntityToDrawing(newGrid, false);
                isDrawNew = true;
                let pt3d = new McGePoint3d(...newStJoint.m_pt);
                let dist = pt3d.distanceTo(intersectPt).toFixed(0);
                const childGridC = getEntityData({
                  Guid: childGrid.Guid,
                  classTypeName: "rlGridC",
                });
                childGridC.saveEditRevokeData();
                childGridC.Length = dist;
                childGridC.updateThisObj(childGridC);
              }
            }
          }
        }
      }
      if (!isDrawNew) break;
    }
  }
  //斜线
  // console.log("jointDataGroup", jointDataGroup);
  //创建斜的网格
  for (let i = 0; i < datasObliqueGroup.length; i++) {
    let group = datasObliqueGroup[i];
    for (let j = 0; j < group.length; j++) {
      let item = group[j].gridC;
      let StJoint = jointDataGroup.find(
        (item1) => item1.Guid == item.m_stJoint.Guid
      );
      let EdJoint = jointDataGroup.find(
        (item1) => item1.Guid == item.m_edJoint.Guid
      );
      if (StJoint && EdJoint) {
        let newGrid = new rlGridData();
        newGrid.initData({
          m_stJoint: StJoint,
          m_edJoint: EdJoint,
          Guid: item.Guid,
          m_Axis: null,
        });
        await addEntityToDrawing(newGrid, false);
      }
    }
  }
  //更新显示
  rlAppObj.rlMxDrawObject.updateDisplay();
  saveDatabaseStore();
};

//获取线段的中点
export const getLineCenterPt = (line) => {
  let stPt = new McGePoint3d(...line.m_stJoint.m_pt);
  let edPt = new McGePoint3d(...line.m_edJoint.m_pt);
  return new McGePoint3d((stPt.x + edPt.x) / 2, (stPt.y + edPt.y) / 2, 0);
};

//按与X轴平行和Y轴平行分组
export const getSketchLineGroupByAxis = (datas) => {
  let datasX = []; //X轴平行
  let datasY = []; //Y轴平行
  let datasOblique = []; //斜线
  let ptX1 = new McGePoint3d(1, 0, 0);
  let ptX2 = new McGePoint3d(-1, 0, 0);
  let ptY1 = new McGePoint3d(0, 1, 0);
  let ptY2 = new McGePoint3d(0, -1, 0);
  for (let i = 0; i < datas.length; i++) {
    let item = datas[i];
    let stPt = new McGePoint3d(...item.gridC.m_stJoint.m_pt);
    let edPt = new McGePoint3d(...item.gridC.m_edJoint.m_pt);
    if (isParallel(ptX1, ptX2, stPt, edPt)) {
      datasX.push(item);
    } else if (isParallel(ptY1, ptY2, stPt, edPt)) {
      datasY.push(item);
    } else {
      datasOblique.push(item);
    }
  }
  //把相连的线段连起来分组
  let datasXGroup = [];
  let datasYGroup = [];
  let datasObliqueGroup = [];

  // 辅助函数：判断两条线段是否相连，使用更小的容差
  const areLinesConnected = (line1, line2) => {
    const st1 = new McGePoint3d(...line1.gridC.m_stJoint.m_pt);
    const ed1 = new McGePoint3d(...line1.gridC.m_edJoint.m_pt);
    const st2 = new McGePoint3d(...line2.gridC.m_stJoint.m_pt);
    const ed2 = new McGePoint3d(...line2.gridC.m_edJoint.m_pt);

    // 使用更精确的点相等判断
    return (
      isPointEqual(st1, st2, 0.01) ||
      isPointEqual(st1, ed2, 0.01) ||
      isPointEqual(ed1, st2, 0.01) ||
      isPointEqual(ed1, ed2, 0.01)
    );
  };

  // 查找所有连接的线段组
  const findConnectedLines = (lines) => {
    if (lines.length === 0) return [];

    // 创建邻接表表示线段之间的连接关系
    const adjacencyList = {};
    for (let i = 0; i < lines.length; i++) {
      adjacencyList[i] = [];
      for (let j = 0; j < lines.length; j++) {
        if (i !== j && areLinesConnected(lines[i], lines[j])) {
          adjacencyList[i].push(j);
        }
      }
    }

    // 使用BFS查找所有连通分量
    const visited = new Set();
    const groups = [];

    for (let i = 0; i < lines.length; i++) {
      if (visited.has(i)) continue;

      // 开始新的连通分量
      const group = [];
      const queue = [i];
      visited.add(i);

      while (queue.length > 0) {
        const current = queue.shift();
        group.push(lines[current]);

        // 访问所有相邻的线段
        for (const neighbor of adjacencyList[current]) {
          if (!visited.has(neighbor)) {
            visited.add(neighbor);
            queue.push(neighbor);
          }
        }
      }

      // 将连通分量添加到结果中
      if (group.length > 0) {
        groups.push(group);
      }
    }

    return groups;
  };

  // 重新排序每个组内的线段，使它们按照连接顺序排列
  const reorderGroupLinesByConnection = (group) => {
    if (group.length <= 1) return group;

    // 创建一个新数组来存储排序后的线段
    const orderedLines = [group[0]];
    const remainingLines = new Set(group.slice(1));

    // 不断添加与当前最后一个线段相连的线段
    while (remainingLines.size > 0) {
      const lastLine = orderedLines[orderedLines.length - 1];
      let foundNext = false;

      // 寻找与末尾线段相连的下一个线段
      for (const nextLine of remainingLines) {
        if (areLinesConnected(lastLine, nextLine)) {
          orderedLines.push(nextLine);
          remainingLines.delete(nextLine);
          foundNext = true;
          break;
        }
      }

      // 如果没找到下一个连接线段，那么检查是否有线段与第一个线段相连
      if (!foundNext && remainingLines.size > 0) {
        const firstLine = orderedLines[0];
        for (const nextLine of remainingLines) {
          if (areLinesConnected(firstLine, nextLine)) {
            // 在数组开头添加
            orderedLines.unshift(nextLine);
            remainingLines.delete(nextLine);
            foundNext = true;
            break;
          }
        }
      }

      // 如果仍然没找到连接的线段，就随机添加一个剩余的线段并开始新的子链
      if (!foundNext && remainingLines.size > 0) {
        const nextLine = remainingLines.values().next().value;
        orderedLines.push(nextLine);
        remainingLines.delete(nextLine);
      }
    }

    return orderedLines;
  };

  //获取所有的斜线
  const getObliqueGroup = () => {
    let datasObliqueGroup = [];
    const allGridC = store.state.rlEntData.totalEntityData["rlGridC"];
    for (let i = 0; i < allGridC.length; i++) {
      let item = allGridC[i];
      let stPt = new McGePoint3d(...item.m_stJoint.m_pt);
      let edPt = new McGePoint3d(...item.m_edJoint.m_pt);
      if (
        !isParallel(ptX1, ptX2, stPt, edPt) &&
        !isParallel(ptY1, ptY2, stPt, edPt)
      ) {
        datasObliqueGroup.push(item);
      }
    }
    return datasObliqueGroup;
  };

  // 先找出所有连通分量
  const xGroups = findConnectedLines(datasX);
  const yGroups = findConnectedLines(datasY);
  const obliqueGroups = findConnectedLines(datasOblique);

  // 对每个连通分量内的线段按照连接顺序重新排序
  datasXGroup = xGroups.map((group) => reorderGroupLinesByConnection(group));
  datasYGroup = yGroups.map((group) => reorderGroupLinesByConnection(group));
  datasObliqueGroup = obliqueGroups.map((group) =>
    reorderGroupLinesByConnection(group)
  );

  return {
    datasXGroup,
    datasYGroup,
    datasObliqueGroup,
  };
};

//给所有草图线赋长度
export const setSketchLineLength = (gridCDistGroup) => {
  let datas = [];
  const setLength = (group, depth = 0) => {
    // 添加最大递归深度限制
    if (depth > 100) {
      console.warn("setLength: 递归深度过大，可能存在循环引用");
      return [];
    }

    // 添加有效性检查
    if (!group || !group.gridC || !Array.isArray(group.gridC)) {
      return [];
    }

    let tempDatas = [];
    let Length = group.length;

    for (let i = 0; i < group.gridC.length; i++) {
      let item = group.gridC[i];
      if (item) {
        tempDatas.push({
          gridC: item,
          Length: Length,
        });
      }
    }

    // if (Length != 0) {
    //   for (let i = 0; i < group.gridC.length; i++) {
    //     let item = group.gridC[i];
    //     if (item) {
    //       tempDatas.push({
    //         gridC: item,
    //         Length: Length,
    //       });
    //     }
    //   }
    // } else if (!group.isOblique) {
    //   for (let i = 0; i < group.gridC.length; i++) {
    //     let item = group.gridC[i];
    //     if (item) {
    //       tempDatas.push({
    //         gridC: item,
    //         Length: Length,
    //       });
    //     }
    //   }
    // }

    // 递归处理子组
    if (
      group.childGroup &&
      Array.isArray(group.childGroup) &&
      group.childGroup.length > 0
    ) {
      for (let i = 0; i < group.childGroup.length; i++) {
        let childGroup = group.childGroup[i];
        if (childGroup && Array.isArray(childGroup)) {
          for (let j = 0; j < childGroup.length; j++) {
            if (childGroup[j]) {
              // 增加递归深度计数
              const childData = setLength(childGroup[j], depth + 1);
              if (childData && childData.length > 0) {
                tempDatas.push(...childData);
              }
            }
          }
        }
      }
    }

    return tempDatas;
  };

  for (let i = 0; i < gridCDistGroup.length; i++) {
    let group = gridCDistGroup[i];
    let tempDatas = setLength(group);
    for (let j = 0; j < tempDatas.length; j++) {
      let index = datas.findIndex(
        (item) => item.gridC.Guid === tempDatas[j].gridC.Guid
      );
      if (index === -1) datas.push(tempDatas[j]);
    }
  }
  return datas;
};
//校验已输入数据的长度是否合理
export const checkInputDataLength = (gridCDistGroup) => {
  let tipsGroup = []; //对比数据有误,用于提示
  const comparisonChileGroup = (mainGroup, depth = 0) => {
    // 添加最大递归深度限制
    if (depth > 100) {
      console.warn("comparisonChileGroup: 递归深度过大，可能存在循环引用");
      return [];
    }

    // 添加有效性检查
    if (!mainGroup || !mainGroup.gridC) {
      return [];
    }

    let Length = mainGroup.length;
    let localTipsGroup = []; // 本地存储当前遍历找到的问题数据

    if (
      Length != 0 &&
      mainGroup.childGroup &&
      mainGroup.childGroup.length > 0
    ) {
      for (let i = 0; i < mainGroup.childGroup.length; i++) {
        let childGroup = mainGroup.childGroup[i];
        if (!childGroup || !Array.isArray(childGroup)) continue;

        let childTotalLen = 0; //子线段总长度
        for (let j = 0; j < childGroup.length; j++) {
          if (childGroup[j] && typeof childGroup[j].length === "number") {
            childTotalLen += childGroup[j].length;
          }
        }

        let overLap = isOverLap(mainGroup, childGroup); //是否重叠
        if (overLap && childTotalLen != Length) {
          localTipsGroup.push({
            mainEntity: mainGroup.gridC,
            childEntity: childGroup,
          }); // 使用本地变量存储
        } else if (!overLap && childTotalLen > Length) {
          localTipsGroup.push({
            mainEntity: mainGroup.gridC,
            childEntity: childGroup,
          }); // 使用本地变量存储
        }
      }
    }

    // 处理子组的递归调用
    if (mainGroup.childGroup && mainGroup.childGroup.length > 0) {
      for (let j = 0; j < mainGroup.childGroup.length; j++) {
        let childGroup = mainGroup.childGroup[j];
        if (!childGroup || !Array.isArray(childGroup)) continue;

        for (let k = 0; k < childGroup.length; k++) {
          if (!childGroup[k]) continue;

          // 增加递归深度计数
          let tempTipsGroup = comparisonChileGroup(childGroup[k], depth + 1);
          if (tempTipsGroup && tempTipsGroup.length > 0) {
            localTipsGroup.push(...tempTipsGroup); // 合并子递归结果到本地变量
          }
        }
      }
    }

    return localTipsGroup; // 返回本地收集的结果
  };
  for (let s = 0; s < gridCDistGroup.length; s++) {
    let group = gridCDistGroup[s];
    let results = comparisonChileGroup(group);
    if (results.length > 0) {
      tipsGroup.push(...results);
    }
  }
  console.log("checkInputDataLength 已输入数据的长度不合理:", tipsGroup);

  return tipsGroup;
};

//从childGroups中找能够组合起来与mainGroup完全重合的线段组
export const findMainGroup = (mainGroup, childGroups) => {
  // 如果没有子线组，直接返回空数组
  if (!childGroups || childGroups.length === 0) return [];

  // 获取主线段的长度
  const mainLength = mainGroup.stPt.distanceTo(mainGroup.edPt);

  // 存储所有可能的组合
  const possibleCombinations = [];
  // 最大递归深度限制，防止嵌套过深
  const MAX_RECURSION_DEPTH = 1000;
  // 最大访问节点数量限制，防止分支爆炸
  const MAX_NODE_VISITS = 20000;
  let exceededDepthLimit = false;
  let nodeVisits = 0;

  // 递归函数，尝试所有可能的组合
  const findCombination = (
    remainingGroups,
    currentCombination,
    currentLength,
    depth = 0
  ) => {
    // 若已超限，则立即终止所有分支
    if (exceededDepthLimit) {
      return;
    }

    // 访问计数，上限保护（广度大时依然可能卡顿）
    nodeVisits++;
    if (nodeVisits > MAX_NODE_VISITS) {
      exceededDepthLimit = true;
      return;
    }
    // 当递归深度超过最大限制时，标记并停止进一步递归
    if (depth > MAX_RECURSION_DEPTH) {
      exceededDepthLimit = true;
      return;
    }
    // 如果当前组合的总长度与主线段长度相等（在误差范围内），则找到一个解
    if (Math.abs(currentLength - mainLength) < 0.1) {
      possibleCombinations.push([...currentCombination]);
      return;
    }

    // 如果当前长度已经超过主线段长度，或没有更多的线段可选，则返回
    if (currentLength > mainLength + 0.1 || remainingGroups.length === 0) {
      return;
    }

    // 尝试每个剩余线段
    for (let i = 0; i < remainingGroups.length; i++) {
      if (exceededDepthLimit) {
        break;
      }
      const group = remainingGroups[i];
      const groupLength = group.stPt.distanceTo(group.edPt);

      // 检查当前线段是否在主线段上
      if (
        ptOnLine(mainGroup.stPt, mainGroup.edPt, group.stPt) !== -1 &&
        ptOnLine(mainGroup.stPt, mainGroup.edPt, group.edPt) !== -1
      ) {
        // 将当前线段添加到组合中
        currentCombination.push(group);

        // 递归尝试剩余的线段
        const nextRemainingGroups = [...remainingGroups];
        nextRemainingGroups.splice(i, 1);
        findCombination(
          nextRemainingGroups,
          currentCombination,
          currentLength + groupLength,
          depth + 1
        );

        // 回溯，移除当前线段
        currentCombination.pop();
      }
    }
  };

  // 开始搜索组合
  findCombination(childGroups, [], 0, 0);
  // console.log("possibleCombinations", possibleCombinations);

  // 返回找到的所有可能组合
  return exceededDepthLimit ? [] : possibleCombinations;
};

//校验还有哪些草图组的距离有没有错误
export const checkSketchLength = async (gridCDistGroup) => {
  showFullScreenLoading("正在检查草图组的长度..");
  // 确保 showFullScreenLoading 执行完毕
  await new Promise((resolve) => setTimeout(resolve, 50));
  // 使用Set保存已处理过的group，避免循环引用导致的死循环
  const processedGroups = new Set();
  const MAX_SET_LENGTH_COUNT = 1000; // 设置一个安全上限，避免无限循环
  let setLengthNum = 0;

  const checkGroup = (group, depth = 0) => {
    // 添加最大递归深度限制
    if (depth > 100) {
      console.warn("checkGroup: 递归深度过大，可能存在循环引用");
      return [];
    }

    // 添加有效性检查
    if (!group || !group.gridC) {
      return [];
    }

    // 使用索引检测循环引用，如果能用唯一标识更好
    const groupId =
      group.index !== undefined
        ? group.index
        : JSON.stringify(group.gridC?.[0]?.Guid);
    if (processedGroups.has(groupId)) {
      return []; // 该组已处理过，避免循环引用
    }
    processedGroups.add(groupId);

    let errorGridC = [];
    if (group.length == 0 && group.isOblique) {
      // errorGridC.push(group);
      //找子的总长
      let childTotalLen = 0;
      //作为主找子的总长
      if (group.childGroup && group.childGroup.length > 0) {
        for (let i = 0; i < group.childGroup.length; i++) {
          let temoChildLength = 0;
          if (!isOverLap(group, group.childGroup[i])) {
            continue;
          }
          console.log("group.childGroup[i]", group.childGroup[i]);

          for (let j = 0; j < group.childGroup[i].length; j++) {
            if (!group.childGroup[i][j]) continue; // 跳过无效元素
            temoChildLength += group.childGroup[i][j].length;
            if (group.childGroup[i][j].length == 0) {
              temoChildLength = 0;
              break;
            }
          }
          if (temoChildLength != 0) {
            if (childTotalLen != 0) {
              if (temoChildLength > childTotalLen) {
                errorGridC.push(group);
                childTotalLen = -1;
                break;
              }
            }
            childTotalLen = temoChildLength;
          }
        }
        //没有找到完全一致的子,计算有没有能够多个子组合能与主相等的组合
        if (childTotalLen == 0) {
          let allChildGroup = [];
          for (let i = 0; i < group.childGroup.length; i++) {
            if (!Array.isArray(group.childGroup[i])) continue;

            for (let s = 0; s < group.childGroup[i].length; s++) {
              if (group.childGroup[i][s]) {
                allChildGroup.push(group.childGroup[i][s]);
              }
            }
          }
          let possibleCombinations = findMainGroup(group, allChildGroup);
          console.log("possibleCombinations", possibleCombinations);

          for (let g = 0; g < possibleCombinations.length; g++) {
            if (!isOverLap(group, possibleCombinations[g])) continue;
            let tempChildLength = 0;
            for (let h = 0; h < possibleCombinations[g].length; h++) {
              if (
                !possibleCombinations[g][h] ||
                possibleCombinations[g][h].length == 0
              ) {
                tempChildLength = 0;
                break;
              }
              tempChildLength += possibleCombinations[g][h].length;
            }
            if (tempChildLength != 0) {
              childTotalLen = tempChildLength;
              break;
            }
          }
        }
      }

      //作为子找主
      if (
        childTotalLen != -1 &&
        group.mainGroup &&
        group.mainGroup.length > 0
      ) {
        let index = group.index;
        let isOk = false;
        // 设置一个最大迭代次数，避免无限循环
        let loopCount = 0;
        const MAX_LOOP_COUNT = 10000;
        // console.log("group.mainGroup", group.mainGroup);
        // return;
        for (
          let i = 0;
          i < group.mainGroup.length && loopCount < MAX_LOOP_COUNT;
          i++
        ) {
          if (!group.mainGroup[i] || !group.mainGroup[i].childGroup) continue;

          for (
            let j = 0;
            j < group.mainGroup[i].childGroup.length &&
            loopCount < MAX_LOOP_COUNT;
            j++
          ) {
            if (!Array.isArray(group.mainGroup[i].childGroup[j])) continue;

            for (
              let k = 0;
              k < group.mainGroup[i].childGroup[j].length &&
              loopCount < MAX_LOOP_COUNT;
              k++
            ) {
              loopCount++;
              if (!group.mainGroup[i].childGroup[j][k]) continue;

              if (group.mainGroup[i].childGroup[j][k].index == index) {
                if (
                  isOverLap(
                    group.mainGroup[i],
                    group.mainGroup[i].childGroup[j]
                  )
                ) {
                  let temoChildLength = 0;
                  let zeroLengthNum = 0;
                  for (
                    let l = 0;
                    l < group.mainGroup[i].childGroup[j].length;
                    l++
                  ) {
                    if (!group.mainGroup[i].childGroup[j][l]) continue;
                    temoChildLength +=
                      group.mainGroup[i].childGroup[j][l].length;
                    if (group.mainGroup[i].childGroup[j][l].length == 0) {
                      zeroLengthNum++;
                    }
                  }

                  if (temoChildLength > group.mainGroup[i].length) {
                    errorGridC.push(group);
                    break;
                  } else if (
                    zeroLengthNum == 1 &&
                    temoChildLength < group.mainGroup[i].length &&
                    setLengthNum < MAX_SET_LENGTH_COUNT
                  ) {
                    let lengthTemp =
                      group.mainGroup[i].length - temoChildLength;
                    if (lengthTemp == childTotalLen || childTotalLen == 0) {
                      for (let s = 0; s < group.gridC.length; s++) {
                        if (
                          !group.gridC[s] ||
                          typeof group.gridC[s].saveEditRevokeData !==
                            "function"
                        )
                          continue;
                        group.gridC[s].saveEditRevokeData();
                        group.gridC[s].Length = lengthTemp;
                        group.gridC[s].updateThisObj(group.gridC[s]);
                      }
                      saveDatabaseStore();
                      setLengthNum++;
                      isOk = true;
                    }
                  }
                } else {
                  //自身当前段不与主线段完全重叠,计算有没有能够多个子组合能与主相等的组合
                  let allChildGroup = [];
                  for (
                    let y = 0;
                    y < group.mainGroup[i].childGroup.length;
                    y++
                  ) {
                    if (!Array.isArray(group.mainGroup[i].childGroup[y]))
                      continue;

                    for (
                      let s = 0;
                      s < group.mainGroup[i].childGroup[y].length;
                      s++
                    ) {
                      if (group.mainGroup[i].childGroup[y][s]) {
                        allChildGroup.push(group.mainGroup[i].childGroup[y][s]);
                      }
                    }
                  }
                  // console.log("allChildGroup", allChildGroup);

                  let possibleCombinations = findMainGroup(
                    group.mainGroup[i],
                    allChildGroup
                  );
                  for (let g = 0; g < possibleCombinations.length; g++) {
                    if (!isOverLap(group.mainGroup[i], possibleCombinations[g]))
                      continue;
                    let index = possibleCombinations[g].findIndex(
                      (mm) => mm && mm.index == group.index
                    );
                    if (index == -1) continue;
                    let tempChildLength = 0;
                    for (let h = 0; h < possibleCombinations[g].length; h++) {
                      if (!possibleCombinations[g][h]) continue;
                      if (
                        possibleCombinations[g][h].length == 0 &&
                        h != index
                      ) {
                        tempChildLength = 0;
                        break;
                      }
                      tempChildLength += possibleCombinations[g][h].length;
                    }
                    if (
                      tempChildLength != 0 &&
                      setLengthNum < MAX_SET_LENGTH_COUNT
                    ) {
                      if (group.mainGroup[i].length > tempChildLength) {
                        let lengthTemp =
                          group.mainGroup[i].length - tempChildLength;
                        for (let s = 0; s < group.gridC.length; s++) {
                          if (
                            !group.gridC[s] ||
                            typeof group.gridC[s].saveEditRevokeData !==
                              "function"
                          )
                            continue;
                          group.gridC[s].saveEditRevokeData();
                          group.gridC[s].Length = lengthTemp;
                          group.gridC[s].updateThisObj(group.gridC[s]);
                        }
                        saveDatabaseStore();
                        setLengthNum++;
                        isOk = true;
                      }
                      break;
                    }
                  }
                }
              }
              if (isOk) break;
            }
            if (isOk) break;
          }
          if (isOk) break;
        }

        if (loopCount >= MAX_LOOP_COUNT) {
          console.warn("检测到可能的死循环，强制退出处理");
        }

        if (!isOk && setLengthNum < MAX_SET_LENGTH_COUNT) {
          if (childTotalLen > 0) {
            for (let s = 0; s < group.gridC.length; s++) {
              if (
                !group.gridC[s] ||
                typeof group.gridC[s].saveEditRevokeData !== "function"
              )
                continue;
              group.gridC[s].saveEditRevokeData();
              group.gridC[s].Length = childTotalLen;
              group.gridC[s].updateThisObj(group.gridC[s]);
            }
            saveDatabaseStore();
            setLengthNum++;
          } else {
            //网格是0值,且与斜线相连
            let isTrue = false;
            if (group.gridC.length == 1 && group.gridC[0]) {
              let grid = group.gridC[0];
              if (!grid.m_stJoint || !grid.m_edJoint) {
                errorGridC.push(group);
                // 不要使用跳转语句，直接设置isTrue为false让后面的条件处理
                isTrue = false;
              } else {
                // 移动原来的代码到else块中，只在有效时执行
                let stGrids = grid.m_stJoint.m_gridIds;
                let edGrids = grid.m_edJoint.m_gridIds;

                if (Array.isArray(stGrids)) {
                  for (let jj = 0; jj < stGrids.length; jj++) {
                    let stGrid = getEntityData({
                      Guid: stGrids[jj],
                      classTypeName: "rlGridC",
                    });
                    if (!stGrid || !stGrid.m_stJoint || !stGrid.m_edJoint)
                      continue;

                    let stt = new McGePoint3d(...stGrid.m_stJoint.m_pt);
                    let edt = new McGePoint3d(...stGrid.m_edJoint.m_pt);
                    if (
                      !isParallel(
                        stt,
                        edt,
                        new McGePoint3d(1000, 0, 0),
                        new McGePoint3d(-1000, 0, 0)
                      ) &&
                      !isParallel(
                        stt,
                        edt,
                        new McGePoint3d(0, 1000, 0),
                        new McGePoint3d(0, -1000, 0)
                      )
                    ) {
                      isTrue = true;
                      break;
                    }
                  }
                }

                if (!isTrue && Array.isArray(edGrids)) {
                  for (let jj = 0; jj < edGrids.length; jj++) {
                    let edGrid = getEntityData({
                      Guid: edGrids[jj],
                      classTypeName: "rlGridC",
                    });
                    if (!edGrid || !edGrid.m_stJoint || !edGrid.m_edJoint)
                      continue;

                    let stt = new McGePoint3d(...edGrid.m_stJoint.m_pt);
                    let edt = new McGePoint3d(...edGrid.m_edJoint.m_pt);
                    if (
                      !isParallel(
                        stt,
                        edt,
                        new McGePoint3d(1000, 0, 0),
                        new McGePoint3d(-1000, 0, 0)
                      ) &&
                      !isParallel(
                        stt,
                        edt,
                        new McGePoint3d(0, 1000, 0),
                        new McGePoint3d(0, -1000, 0)
                      )
                    ) {
                      isTrue = true;
                      break;
                    }
                  }
                }
              }
            }
            if (!isTrue) {
              errorGridC.push(group);
            }
          }
        }
      } else if (childTotalLen > 0 && setLengthNum < MAX_SET_LENGTH_COUNT) {
        for (let s = 0; s < group.gridC.length; s++) {
          if (
            !group.gridC[s] ||
            typeof group.gridC[s].saveEditRevokeData !== "function"
          )
            continue;
          group.gridC[s].saveEditRevokeData();
          group.gridC[s].Length = childTotalLen;
          group.gridC[s].updateThisObj(group.gridC[s]);
        }
        saveDatabaseStore();
        setLengthNum++;
      } else if (childTotalLen == 0) {
        //网格是0值,且与斜线相连
        let isTrue = false;
        if (group.gridC.length == 1 && group.gridC[0]) {
          let grid = group.gridC[0];
          if (!grid.m_stJoint || !grid.m_edJoint) {
            errorGridC.push(group);
            // 删除有问题的return语句，简单设置isTrue为false
            isTrue = false;
          } else {
            // 移动原来的代码到else块中
            let stGrids = grid.m_stJoint.m_gridIds;
            let edGrids = grid.m_edJoint.m_gridIds;

            if (Array.isArray(stGrids)) {
              for (let jj = 0; jj < stGrids.length; jj++) {
                let stGrid = getEntityData({
                  Guid: stGrids[jj],
                  classTypeName: "rlGridC",
                });
                if (!stGrid || !stGrid.m_stJoint || !stGrid.m_edJoint) continue;

                let stt = new McGePoint3d(...stGrid.m_stJoint.m_pt);
                let edt = new McGePoint3d(...stGrid.m_edJoint.m_pt);
                if (
                  !isParallel(
                    stt,
                    edt,
                    new McGePoint3d(1000, 0, 0),
                    new McGePoint3d(-1000, 0, 0)
                  ) &&
                  !isParallel(
                    stt,
                    edt,
                    new McGePoint3d(0, 1000, 0),
                    new McGePoint3d(0, -1000, 0)
                  )
                ) {
                  isTrue = true;
                  break;
                }
              }
            }

            if (!isTrue && Array.isArray(edGrids)) {
              for (let jj = 0; jj < edGrids.length; jj++) {
                let edGrid = getEntityData({
                  Guid: edGrids[jj],
                  classTypeName: "rlGridC",
                });
                if (!edGrid || !edGrid.m_stJoint || !edGrid.m_edJoint) continue;

                let stt = new McGePoint3d(...edGrid.m_stJoint.m_pt);
                let edt = new McGePoint3d(...edGrid.m_edJoint.m_pt);
                if (
                  !isParallel(
                    stt,
                    edt,
                    new McGePoint3d(1000, 0, 0),
                    new McGePoint3d(-1000, 0, 0)
                  ) &&
                  !isParallel(
                    stt,
                    edt,
                    new McGePoint3d(0, 1000, 0),
                    new McGePoint3d(0, -1000, 0)
                  )
                ) {
                  isTrue = true;
                  break;
                }
              }
            }
          }
        }
        if (!isTrue) {
          errorGridC.push(group);
        }
      }
    } else if (group.isOblique) {
      let tmpErrorGroup = [];
      for (let i = 0; i < group.gridC.length; i++) {
        if (!group.gridC[i]) continue;
        let modelNum = group.gridC[i].Length;
        if (store.state.inspectionStore.isRoundSketch)
          modelNum = ret50Modulus(group.gridC[i].Length);
        let totalData = modelNum;
        if (
          store.state.inspectionStore.isAddWallThicknessSketch &&
          modelNum != 0
        )
          totalData = modelNum + group.gridC[i].Thickness;
        if (group.gridC[i].Length == 0) continue;
        else if (totalData != group.length) {
          tmpErrorGroup.push(group);
          break;
        }
      }
      if (tmpErrorGroup.length > 0) {
        errorGridC.push(...tmpErrorGroup);
      }
    }

    // 处理子组的递归调用
    if (group.childGroup && group.childGroup.length > 0) {
      // 限制处理的子组数量，防止极端情况
      const maxChildGroupsToProcess = Math.min(group.childGroup.length, 10000);

      for (let i = 0; i < maxChildGroupsToProcess; i++) {
        if (!Array.isArray(group.childGroup[i])) continue;

        // 限制处理的子元素数量，防止极端情况
        const maxChildrenToProcess = Math.min(
          group.childGroup[i].length,
          10000
        );

        for (let j = 0; j < maxChildrenToProcess; j++) {
          if (!group.childGroup[i][j]) continue;

          // 增加递归深度计数
          const childErrors = checkGroup(group.childGroup[i][j], depth + 1);
          if (childErrors && childErrors.length > 0) {
            errorGridC.push(...childErrors);
          }
        }
      }
    }

    return errorGridC;
  };

  let tipsGroup = [];

  // 限制处理组的最大数量
  const maxGroupsToProcess = Math.min(gridCDistGroup.length, 10000);

  for (let i = 0; i < maxGroupsToProcess; i++) {
    if (!gridCDistGroup[i]) continue;

    const groupErrors = checkGroup(gridCDistGroup[i]);
    if (groupErrors && groupErrors.length > 0) {
      tipsGroup.push(...groupErrors);
    }

    // 如果setLengthNum已达到上限，停止处理以防止无限循环
    if (setLengthNum >= MAX_SET_LENGTH_COUNT) {
      console.warn(
        `已达到最大修改次数 ${MAX_SET_LENGTH_COUNT}，停止处理以防止可能的死循环`
      );
      break;
    }
  }

  console.log("checkSketchLength 草图线有0值:", tipsGroup);
  // 隐藏 loading
  tryHideFullScreenLoading();
  return { errorGridC: tipsGroup, setLengthNum };
};

//删掉没有用的线段
export const deleteNoUseLine = () => {
  const allJointC = store.state.rlEntData.totalEntityData["rlJointC"];
  let delJointC = []; //需要删除的节点
  let delGridC = []; //需要删除的网格
  for (let i = 0; i < allJointC.length; i++) {
    //节点存在柱子不删
    if (allJointC[i].m_cloumId) continue;
    //节点关联1个网格以上不删
    if (allJointC[i].m_gridIds.length > 1) continue;
    //节点关联0个网格删除
    if (allJointC[i].m_gridIds.length == 0) {
      delJointC.push(allJointC[i]);
      continue;
    }
    if (allJointC[i].m_gridIds.length == 1) {
      let gridCGuid = allJointC[i].m_gridIds[0];
      const rlGridCData = getEntityData({
        Guid: gridCGuid,
        classTypeName: "rlGridC",
      });
      if (rlGridCData) {
        //网格长度不为0不删
        if (rlGridCData.Length != 0) continue;
        //网格关联墙、梁、隔墙不删
        if (
          rlGridCData.m_wallId &&
          rlGridCData.m_beamId &&
          rlGridCData.m_partitionWallId
        )
          continue;
        delGridC.push(rlGridCData);
      } else {
        delJointC.push(allJointC[i]);
      }
    }
  }
  delJointC.forEach((item) => {
    item.erase();
  });
  delGridC.forEach((item) => {
    item.erase();
  });
  return;
};
//判断线段是否重叠,lineGroup是否与line完全重合
export const isOverLap = (line, lineGroup) => {
  let lineLength = line.stPt.distanceTo(line.edPt);
  let lineGroupLength = 0;
  for (let i = 0; i < lineGroup.length; i++) {
    lineGroupLength += lineGroup[i].stPt.distanceTo(lineGroup[i].edPt);
  }
  if (Math.abs(lineLength - lineGroupLength) < 1) return true;
  // 所有检查都通过，说明lineGroup完全覆盖了line
  return false;
};

//返回50模数
export const ret50Modulus = (length) => {
  if (!length || isNaN(length)) return 0;

  const quotient = Math.floor(length / 50);
  const remainder = length % 50;

  if (remainder >= 1 && remainder <= 24) {
    // 余数在1~24之间，去掉尾数
    return quotient * 50;
  } else if (remainder >= 25 && remainder <= 49) {
    // 余数在25~49之间，补足50
    return (quotient + 1) * 50;
  } else if (remainder >= 51 && remainder <= 74) {
    // 余数在51~74之间，尾数是50
    return quotient * 50 + 50;
  } else if (remainder >= 75 && remainder <= 99) {
    // 余数在75~99之间，补到100
    return (quotient + 1) * 50 + 50;
  }

  // 如果余数是0或50，直接返回原长度
  return length;
};

//草图线分组
export const getSketchLineGroup = () => {
  const allGridC = store.state.rlEntData.totalEntityData["rlGridC"];
  let points = [];
  //获取所有草图网格的点
  allGridC.forEach((item) => {
    points.push(new McGePoint3d(...item.m_stJoint.m_pt));
    points.push(new McGePoint3d(...item.m_edJoint.m_pt));
  });
  const leftBottomPoint = getLeftBottomPoint(points);

  //以最下角的点为原点,绘制XY轴,左右长度为100000
  const vecX1 = new THREE.Vector3(1, 0, 0);
  const vecX2 = new THREE.Vector3(-1, 0, 0);
  const vecY1 = new THREE.Vector3(0, 1, 0);
  const vecY2 = new THREE.Vector3(0, -1, 0);
  const lineX = new McDbLine();
  lineX.startPoint = MovePt(leftBottomPoint, vecX1, 10000000);
  lineX.endPoint = MovePt(leftBottomPoint, vecX2, 10000000);
  const lineY = new McDbLine();
  lineY.startPoint = MovePt(leftBottomPoint, vecY1, 10000000);
  lineY.endPoint = MovePt(leftBottomPoint, vecY2, 10000000);
  let gridCDistGroup = [];
  let indexMark = 0; //索引标记
  allGridC.forEach((item) => {
    let stPt = new McGePoint3d(...item.m_stJoint.m_pt);
    let edPt = new McGePoint3d(...item.m_edJoint.m_pt);
    let modelNum = item.Length;
    if (store.state.inspectionStore.isRoundSketch)
      modelNum = ret50Modulus(item.Length);
    let totalData = modelNum;
    if (store.state.inspectionStore.isAddWallThicknessSketch && modelNum != 0)
      totalData = modelNum + item.Thickness;
    if (isParallel(lineX.startPoint, lineX.endPoint, stPt, edPt)) {
      //把点投影到X轴上
      let closeStPt = lineX.getClosestPointTo(stPt).val;
      let closeEdPt = lineX.getClosestPointTo(edPt).val;
      let index = gridCDistGroup.findIndex(
        (item) =>
          (isPointEqual(closeStPt, item.stPt, 0.1) ||
            isPointEqual(closeStPt, item.edPt, 0.1)) &&
          (isPointEqual(closeEdPt, item.stPt, 0.1) ||
            isPointEqual(closeEdPt, item.edPt, 0.1))
      );
      if (index === -1) {
        gridCDistGroup.push({
          index: indexMark++,
          stPt: closeStPt,
          edPt: closeEdPt,
          length: totalData,
          gridC: [item],
          childGroup: [],
          mainGroup: [],
          isOblique: true, //是否正交
        });
      } else {
        gridCDistGroup[index].gridC.push(item);
        if (gridCDistGroup[index].length == 0) {
          gridCDistGroup[index].length = totalData;
        }
      }
    } else if (isParallel(lineY.startPoint, lineY.endPoint, stPt, edPt)) {
      //把点投影到Y轴上
      let closeStPt = lineY.getClosestPointTo(stPt).val;
      let closeEdPt = lineY.getClosestPointTo(edPt).val;
      let index = gridCDistGroup.findIndex(
        (item) =>
          (isPointEqual(closeStPt, item.stPt, 0.1) ||
            isPointEqual(closeStPt, item.edPt, 0.1)) &&
          (isPointEqual(closeEdPt, item.stPt, 0.1) ||
            isPointEqual(closeEdPt, item.edPt, 0.1))
      );
      if (index === -1) {
        gridCDistGroup.push({
          index: indexMark++,
          stPt: closeStPt,
          edPt: closeEdPt,
          length: totalData,
          gridC: [item],
          childGroup: [],
          mainGroup: [],
          isOblique: true, //是否正交
        });
      } else {
        gridCDistGroup[index].gridC.push(item);
        if (gridCDistGroup[index].length == 0) {
          gridCDistGroup[index].length = totalData;
        }
      }
    } else {
      let index = gridCDistGroup.findIndex(
        (item) =>
          (isPointEqual(stPt, item.stPt, 0.1) ||
            isPointEqual(stPt, item.edPt, 0.1)) &&
          (isPointEqual(edPt, item.stPt, 0.1) ||
            isPointEqual(edPt, item.edPt, 0.1))
      );
      if (index === -1) {
        gridCDistGroup.push({
          index: indexMark++,
          stPt: stPt,
          edPt: edPt,
          length: totalData,
          gridC: [item],
          childGroup: [],
          mainGroup: [],
          isOblique: false, //是否正交
        });
      } else {
        gridCDistGroup[index].gridC.push(item);
        if (gridCDistGroup[index].length == 0) {
          gridCDistGroup[index].length = totalData;
        }
      }
    }
  });

  // 获取所有草图线分组----暂时屏蔽,有点影响效率
  // let connectedLines = getConnectedLines(allGridC);
  // //把假线段加进来,用于计算其他线段的长度
  // for (let i = 0; i < connectedLines.length; i++) {
  //   if (connectedLines[i].length == 1) continue;
  //   let totalLength = 0;
  //   for (let j = 0; j < connectedLines[i].length; j++) {
  //     totalLength = 0;
  //     if (connectedLines[i][j].Length == 0) {
  //       continue;
  //     }
  //     let modelNum1 = connectedLines[i][j].Length;
  //     if (store.state.inspectionStore.isRoundSketch)
  //       modelNum1 = ret50Modulus(connectedLines[i][j].Length);
  //     let totalData1 = modelNum1;
  //     if (
  //       store.state.inspectionStore.isAddWallThicknessSketch &&
  //       modelNum1 != 0
  //     )
  //       totalData1 = modelNum1 + connectedLines[i][j].Thickness;
  //     totalLength += totalData1;
  //     let points = [];
  //     points.push(new McGePoint3d(...connectedLines[i][j].m_stJoint.m_pt));
  //     points.push(new McGePoint3d(...connectedLines[i][j].m_edJoint.m_pt));
  //     for (let k = j + 1; k < connectedLines[i].length; k++) {
  //       if (connectedLines[i][k].Length == 0) {
  //         break;
  //       }
  //       let modelNum2 = connectedLines[i][k].Length;
  //       if (store.state.inspectionStore.isRoundSketch)
  //         modelNum2 = ret50Modulus(connectedLines[i][k].Length);
  //       let totalData2 = modelNum2;
  //       if (
  //         store.state.inspectionStore.isAddWallThicknessSketch &&
  //         modelNum2 != 0
  //       )
  //         totalData2 = modelNum2 + connectedLines[i][k].Thickness;
  //       totalLength += totalData2;
  //       points.push(new McGePoint3d(...connectedLines[i][k].m_stJoint.m_pt));
  //       points.push(new McGePoint3d(...connectedLines[i][k].m_edJoint.m_pt));
  //       let farthestPoints = getFarthestPoints(points);
  //       if (farthestPoints.length == 2) {
  //         let stPt = farthestPoints[0];
  //         let edPt = farthestPoints[1];
  //         if (isParallel(lineX.startPoint, lineX.endPoint, stPt, edPt)) {
  //           //把点投影到X轴上
  //           let closeStPt = lineX.getClosestPointTo(stPt).val;
  //           let closeEdPt = lineX.getClosestPointTo(edPt).val;
  //           let index = gridCDistGroup.findIndex(
  //             (item) =>
  //               (isPointEqual(closeStPt, item.stPt, 0.1) ||
  //                 isPointEqual(closeStPt, item.edPt, 0.1)) &&
  //               (isPointEqual(closeEdPt, item.stPt, 0.1) ||
  //                 isPointEqual(closeEdPt, item.edPt, 0.1))
  //           );
  //           if (index === -1) {
  //             gridCDistGroup.push({
  //               index: indexMark++,
  //               stPt: closeStPt,
  //               edPt: closeEdPt,
  //               length: totalLength,
  //               gridC: [],
  //               childGroup: [],
  //               mainGroup: [],
  //               isOblique: true, //是否正交
  //             });
  //           } else {
  //             if (gridCDistGroup[index].length == 0) {
  //               gridCDistGroup[index].length = totalLength;
  //             }
  //           }
  //         } else if (isParallel(lineY.startPoint, lineY.endPoint, stPt, edPt)) {
  //           //把点投影到Y轴上
  //           let closeStPt = lineY.getClosestPointTo(stPt).val;
  //           let closeEdPt = lineY.getClosestPointTo(edPt).val;
  //           let index = gridCDistGroup.findIndex(
  //             (item) =>
  //               (isPointEqual(closeStPt, item.stPt, 0.1) ||
  //                 isPointEqual(closeStPt, item.edPt, 0.1)) &&
  //               (isPointEqual(closeEdPt, item.stPt, 0.1) ||
  //                 isPointEqual(closeEdPt, item.edPt, 0.1))
  //           );
  //           if (index === -1) {
  //             gridCDistGroup.push({
  //               index: indexMark++,
  //               stPt: closeStPt,
  //               edPt: closeEdPt,
  //               length: totalLength,
  //               gridC: [],
  //               childGroup: [],
  //               mainGroup: [],
  //               isOblique: true, //是否正交
  //             });
  //           } else {
  //             if (gridCDistGroup[index].length == 0) {
  //               gridCDistGroup[index].length = totalLength;
  //             }
  //           }
  //         } else {
  //           let index = gridCDistGroup.findIndex(
  //             (item) =>
  //               (isPointEqual(stPt, item.stPt, 0.1) ||
  //                 isPointEqual(stPt, item.edPt, 0.1)) &&
  //               (isPointEqual(edPt, item.stPt, 0.1) ||
  //                 isPointEqual(edPt, item.edPt, 0.1))
  //           );
  //           if (index === -1) {
  //             gridCDistGroup.push({
  //               index: indexMark++,
  //               stPt: stPt,
  //               edPt: edPt,
  //               length: totalLength,
  //               gridC: [],
  //               childGroup: [],
  //               mainGroup: [],
  //               isOblique: false, //是否正交
  //             });
  //           } else {
  //             if (gridCDistGroup[index].length == 0) {
  //               gridCDistGroup[index].length = totalLength;
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  // console.log("connectedLines", connectedLines);

  //获取完所有的分组,还需要再分组,把能够重叠的再分组
  let deleteIndex = [];
  for (let i = 0; i < gridCDistGroup.length; i++) {
    let stPt = gridCDistGroup[i].stPt;
    let edPt = gridCDistGroup[i].edPt;
    let overLapGroup = [];
    for (let j = 0; j < gridCDistGroup.length; j++) {
      if (i == j) continue;
      if (
        ptOnLine(stPt, edPt, gridCDistGroup[j].stPt) != -1 &&
        ptOnLine(stPt, edPt, gridCDistGroup[j].edPt) != -1
      )
        overLapGroup.push(gridCDistGroup[j]);
    }
    if (overLapGroup.length > 0) {
      //找出所有相连的线段分在一组
      let mergeGroup = [];
      let visited = new Set(); // 用于记录已访问的线段

      // 辅助函数:检查两条线段是否相连
      const areLinesConnected = (line1, line2) => {
        const st1 = new McGePoint3d(...line1.m_stJoint.m_pt);
        const ed1 = new McGePoint3d(...line1.m_edJoint.m_pt);
        const st2 = new McGePoint3d(...line2.m_stJoint.m_pt);
        const ed2 = new McGePoint3d(...line2.m_edJoint.m_pt);

        return (
          isPointEqual(st1, st2) ||
          isPointEqual(st1, ed2) ||
          isPointEqual(ed1, st2) ||
          isPointEqual(ed1, ed2)
        );
      };

      // 辅助函数:使用DFS找出所有相连的线段
      const findConnectedLines = (startItem, currentGroup) => {
        visited.add(startItem.line);
        currentGroup.push(startItem.group);
        // 遍历所有重叠组中的线
        for (let j = 0; j < overLapGroup1.length; j++) {
          const item = overLapGroup1[j];
          if (!visited.has(item.line)) {
            let isOk = false;
            // 检查startItem的线与当前item的线是否相连
            if (areLinesConnected(startItem.line, item.line)) {
              findConnectedLines(item, currentGroup);
              isOk = true;
            }
            if (isOk) break;
          }
        }
      };

      let overLapGroup1 = [];
      for (let i = 0; i < overLapGroup.length; i++) {
        for (let j = 0; j < overLapGroup[i].gridC.length; j++) {
          overLapGroup1.push({
            line: overLapGroup[i].gridC[j],
            group: overLapGroup[i],
          });
        }
      }

      // 遍历所有重叠组中的线
      for (let j = 0; j < overLapGroup1.length; j++) {
        const item = overLapGroup1[j];
        if (!visited.has(item.line)) {
          let currentGroup = [];
          findConnectedLines(item, currentGroup);
          if (currentGroup.length > 0) {
            // 直接保存currentGroup，不去重
            let isAdd = true;
            for (let u = 0; u < mergeGroup.length; u++) {
              if (mergeGroup[u].length == currentGroup.length) {
                let isTrueNum = 0;
                for (let v = 0; v < currentGroup.length; v++) {
                  if (
                    mergeGroup[u].find(
                      (item) => item.index === currentGroup[v].index
                    )
                  )
                    isTrueNum++;
                }
                if (isTrueNum == currentGroup.length) {
                  isAdd = false;
                  break;
                }
              }
            }
            if (isAdd) mergeGroup.push(currentGroup);
          }
        }
      }

      if (mergeGroup.length > 0) {
        mergeGroup.forEach((itemMerge) => {
          let childGroup = [];
          for (let i = 0; i < itemMerge.length; i++) {
            let index = gridCDistGroup.findIndex(
              (item) => item.index === itemMerge[i].index
            );
            if (index !== -1) {
              deleteIndex.push(index);
              childGroup.push(itemMerge[i]);
            }
          }
          for (let w = 0; w < childGroup.length; w++) {
            childGroup[w].mainGroup.push(gridCDistGroup[i]);
          }
          gridCDistGroup[i].childGroup.push(childGroup);
        });
      }
    }
  }
  deleteIndex.forEach((itemDel) => {
    let index = gridCDistGroup.findIndex((item) => item.index === itemDel);
    if (index !== -1) {
      gridCDistGroup.splice(index, 1);
    }
  });
  return gridCDistGroup;
};

//找到草图线所在的组
export const findSketchLineGroup = (gridC) => {
  // 先检查输入参数
  if (!gridC || gridC.classTypeName !== "rlGridC") return null;

  // 获取所有草图线分组
  let gridCDistGroup = getSketchLineGroup();

  // 使用Set记录已经访问过的组，防止重复访问相同的组
  const visitedGroups = new Set();

  const findGroup = (group, gridC, depth = 0) => {
    // 最大递归深度限制
    if (depth > 100) {
      console.warn("查找深度过大，可能存在循环引用");
      return { retGridC: null, retGroup: null };
    }

    // 检查组是否已访问过，防止循环引用
    const groupId =
      group.index !== undefined
        ? group.index
        : JSON.stringify(group.gridC?.[0]?.Guid);
    if (visitedGroups.has(groupId)) {
      return { retGridC: null, retGroup: null };
    }
    visitedGroups.add(groupId);

    // 判断group是否有效
    if (!group || !group.gridC) {
      return { retGridC: null, retGroup: null };
    }

    // 快速检查当前组
    let retGridC = group.gridC.find((item) => item.Guid === gridC.Guid);
    if (retGridC) {
      return { retGridC, retGroup: group };
    }

    // 只有当有子组时才继续递归
    if (group.childGroup && group.childGroup.length > 0) {
      for (let i = 0; i < group.childGroup.length; i++) {
        if (!group.childGroup[i]) continue; // 跳过无效子组

        for (let j = 0; j < group.childGroup[i].length; j++) {
          if (!group.childGroup[i][j]) continue; // 跳过无效元素

          let tempRetGridC = findGroup(
            group.childGroup[i][j],
            gridC,
            depth + 1
          );
          if (tempRetGridC.retGridC) {
            return tempRetGridC; // 找到结果立即返回
          }
        }
      }
    }

    // 未找到结果
    return { retGridC: null, retGroup: null };
  };

  let groups = [];
  for (let i = 0; i < gridCDistGroup.length; i++) {
    // 每次搜索前重置已访问组集合
    visitedGroups.clear();

    let { retGridC, retGroup } = findGroup(gridCDistGroup[i], gridC);
    if (retGridC) {
      let isMain = gridCDistGroup[i].gridC.some(
        (item) => item.Guid === gridC.Guid
      );
      groups.push({
        mainGroup: gridCDistGroup[i],
        retGroup,
        retGridC,
        isMain,
      });
    }
  }
  return groups;
};

//校验草图线长度是否合理
export const checkSketchLineLength = async (gridC, Length, Thickness) => {
  let groups = findSketchLineGroup(gridC);
  if (!groups) return false;
  let retLength = Length;
  if (store.state.inspectionStore.isRoundSketch)
    retLength = ret50Modulus(Length);
  let totalLength = retLength;
  if (store.state.inspectionStore.isAddWallThicknessSketch && Length != 0)
    totalLength = retLength + Thickness;
  const modifyAllMainLength = async (setLength) => {
    group.gridC.forEach(async (item) => {
      modifyGridCLength(item, setLength);
    });
    // await saveDatabaseStore();
  };
  const modifyGridCLength = async (ent, setLength, Thickness) => {
    ent.saveEditRevokeData();
    ent.Length = Number(setLength);
    ent.Thickness = Number(Thickness);
    ent.drawText();
    ent.updateThisObj(ent);
  };
  let tipsChildGroup = []; //需要提示的子线段
  for (let t = 0; t < groups.length; t++) {
    let { mainGroup, retGridC, isMain, retGroup } = groups[t];
    let tipsGroup1 = compareSketchLine(retGroup, totalLength);
    let tipsGroup2 = compareSketchLineMain(retGroup, totalLength);
    if (tipsGroup1.length > 0 || tipsGroup2.length > 0) {
      tipsChildGroup.push(...tipsGroup1);
      tipsChildGroup.push(...tipsGroup2);
    }
    //再加一次校验,校验自身gridC中给个长度是否一致,不一致,提示
    let gridCGroup = retGroup.gridC;
    if (Length != 0) {
      for (let i = 0; i < gridCGroup.length; i++) {
        if (gridCGroup[i].Guid === gridC.Guid) continue;
        let tempLength = gridCGroup[i].Length;
        if (store.state.inspectionStore.isRoundSketch)
          tempLength = ret50Modulus(gridCGroup[i].Length);
        let tempTotalLength = tempLength;
        if (
          store.state.inspectionStore.isAddWallThicknessSketch &&
          tempLength != 0
        )
          tempTotalLength = tempLength + gridCGroup[i].Thickness;
        if (gridCGroup[i].Length != 0 && tempTotalLength != totalLength)
          tipsChildGroup.push(gridCGroup[i]);
      }
    }
  }

  if (tipsChildGroup.length > 0) {
    const type = await VXETable.modal.confirm(
      "当前输入的长度有错,与其他线段长度不匹配,是否需要写入?"
    );
    if (type == "confirm") {
      await modifyGridCLength(gridC, Length, Thickness);
    }
  } else {
    await modifyGridCLength(gridC, Length, Thickness);
  }
  await saveDatabaseStore();
  return tipsChildGroup;
};

//当前线段作为子线段对比主线段
export const compareSketchLine = (childGroup, Length) => {
  if (Length == 0) return [];
  let tipsGroup = []; //对比数据有误,用于提示
  //主线段,校验是否小于子线段总长度
  for (let i = 0; i < childGroup.mainGroup.length; i++) {
    let mainGroup = childGroup.mainGroup[i];
    let mainLength = mainGroup.length; //主线段长度
    let findChildGroup = [];
    for (let j = 0; j < mainGroup.childGroup.length; j++) {
      let mainFindChild = mainGroup.childGroup[j];
      for (let m = 0; m < mainFindChild.length; m++) {
        if (mainFindChild[m].index === childGroup.index) {
          findChildGroup = mainFindChild;
          break;
        }
      }
      if (findChildGroup.length > 0) break;
    }
    if (findChildGroup.length > 0) {
      let childTotalLen = 0; //子线段总长度
      for (let i = 0; i < findChildGroup.length; i++) {
        if (findChildGroup[i].index !== childGroup.index)
          childTotalLen += findChildGroup[i].length;
      }
      if (childTotalLen + Length > mainLength && mainLength != 0) {
        tipsGroup.push(mainGroup.gridC);
        for (let i = 0; i < findChildGroup.length; i++)
          tipsGroup.push(findChildGroup[i].gridC);
      }
    }
  }

  return tipsGroup;
};

//当前线段作为主线段对比子线段
export const compareSketchLineMain = (mainGroup, Length) => {
  if (Length == 0) return [];
  let tipsGroup = []; //对比数据有误,用于提示
  const comparisonChileGroup = (mainGroup, Length) => {
    for (let i = 0; i < mainGroup.childGroup.length; i++) {
      let childGroup = mainGroup.childGroup[i];
      let childTotalLen = 0; //子线段总长度
      for (let j = 0; j < childGroup.length; j++) {
        childTotalLen += childGroup[j].length;
      }
      if (childTotalLen > Length) {
        tipsGroup.push(mainGroup.gridC);
        for (let j = 0; j < childGroup.length; j++)
          tipsGroup.push(childGroup[j].gridC);
      }
    }
  };
  comparisonChileGroup(mainGroup, Length);
  return tipsGroup;
};

//获取点集中最左下角的点
export const getLeftBottomPoint = (points) => {
  let box = new THREE.Box3();
  for (let i = 0; i < points.length; i++) {
    box.expandByPoint(points[i]);
  }
  return box.min;
};
// 清空正图所有数据
export const clearAllData = () => {
  try {
    if (store.state.rlEntData.totalEntityData) {
      console.log(
        "store.state.rlEntData.totalEntityData",
        store.state.rlEntData.totalEntityData
      );

      //清空当前画布
      // Object.keys(store.state.rlEntData.totalEntityData).forEach((key) => {
      //   if (key == "rlGridC" || key == "rlJointC" || key == "rlAxisC") return;
      //   let data = store.state.rlEntData.totalEntityData[key];
      //   console.log("data", key, data);

      //   for (let j = 0; j < data.length; j++) {
      //     let entity = data[j];
      //     if (entity) {
      //       entity.erase();
      //     }
      //   }
      // });
    }
    // store.commit("rlEntData/clearEntityData");
  } catch (error) {
    console.error("清空画布时出错：", error);
  }
};

//获取所有相连的线段
export const getConnectedLines = (lines) => {
  if (!lines || lines.length === 0) return [];

  // 判断两条线段是否相连且平行
  const areLinesConnected = (line1, line2) => {
    const st1 = new McGePoint3d(...line1.m_stJoint.m_pt);
    const ed1 = new McGePoint3d(...line1.m_edJoint.m_pt);
    const st2 = new McGePoint3d(...line2.m_stJoint.m_pt);
    const ed2 = new McGePoint3d(...line2.m_edJoint.m_pt);

    // 检查线段是否相连
    const isConnected =
      isPointEqual(st1, st2, 0.01) ||
      isPointEqual(st1, ed2, 0.01) ||
      isPointEqual(ed1, st2, 0.01) ||
      isPointEqual(ed1, ed2, 0.01);

    // 检查线段是否平行
    const isParallelLines = isParallel(st1, ed1, st2, ed2);

    // 返回相连且平行
    return isConnected && isParallelLines;
  };

  // 创建邻接表表示线段之间的连接关系
  const adjacencyList = {};
  for (let i = 0; i < lines.length; i++) {
    adjacencyList[i] = [];
    for (let j = 0; j < lines.length; j++) {
      if (i !== j && areLinesConnected(lines[i], lines[j])) {
        adjacencyList[i].push(j);
      }
    }
  }

  // 使用BFS查找所有连通分量
  const visited = new Set();
  const groups = [];

  for (let i = 0; i < lines.length; i++) {
    if (visited.has(i)) continue;

    // 开始新的连通分量
    const group = [];
    const queue = [i];
    visited.add(i);

    while (queue.length > 0) {
      const current = queue.shift();
      group.push(lines[current]);

      // 访问所有相邻的线段
      for (const neighbor of adjacencyList[current]) {
        if (!visited.has(neighbor)) {
          visited.add(neighbor);
          queue.push(neighbor);
        }
      }
    }

    // 将连通分量添加到结果中
    if (group.length > 0) {
      groups.push(group);
    }
  }

  return groups;
};

//获取点集中相隔最远的两个点
export const getFarthestPoints = (points) => {
  let maxDist = 0;
  let farthestPoints = [];
  for (let i = 0; i < points.length; i++) {
    for (let j = i + 1; j < points.length; j++) {
      let dist = points[i].distanceTo(points[j]);
      if (dist > maxDist) {
        maxDist = dist;
        farthestPoints = [points[i], points[j]];
      }
    }
  }
  return farthestPoints;
};

//过滤重复的错误线段
export const filterRepeatErrorLine = (errorGridC, tipsGroup) => {
  let errorDatas = {
    errorGridC: [],
    tipsGroup: [],
  };
  if (errorGridC) {
    let indexs = [];
    for (let i = 0; i < errorGridC.length; i++) {
      if (indexs.includes(errorGridC[i].index)) {
        continue;
      }
      indexs.push(errorGridC[i].index);
      errorDatas.errorGridC.push(errorGridC[i]);
    }
  }
  if (tipsGroup) {
    let indexs = [];
    for (let i = 0; i < tipsGroup.length; i++) {
      if (tipsGroup[i].mainEntity.length == 0) {
        continue;
      }
      let add = true;
      for (let s = 0; s < indexs.length; s++) {
        let includeLength = 0;
        for (let g = 0; g < tipsGroup[i].childEntity.length; g++) {
          if (indexs[s].includes(tipsGroup[i].childEntity[g].index)) {
            includeLength++;
          }
        }
        if (includeLength == tipsGroup[i].childEntity.length) {
          add = false;
          break;
        }
      }
      if (!add) continue;
      let tmp = [];
      for (let g = 0; g < tipsGroup[i].childEntity.length; g++) {
        tmp.push(tipsGroup[i].childEntity[g].index);
      }
      indexs.push(tmp);
      errorDatas.tipsGroup.push(tipsGroup[i]);
    }
  }
  return errorDatas;
};

//获取正图数据
export const getMainModelData = () => {
  let allJoint = store.state.rlEntData.totalEntityData["rlJoint"];
  let allGrid = store.state.rlEntData.totalEntityData["rlGrid"];
  let allSlab = store.state.rlEntData.totalEntityData["rlSlab"];
  allMainModelData = { rlJoint: allJoint, rlGrid: allGrid, rlSlab: allSlab };
};

export const importeMainModel = async () => {
  if (allMainModelData.rlSlab.length > 0) {
    oneMessage.warning("正图中有楼板数据,请先删除楼板数据");
    return;
  }
  const type = await VXETable.modal.confirm(
    "导入正图的模型后,草图的所有模型数据将被清空,而且无法恢复,是否继续?"
  );
  if (type != "confirm") return;
  await clearSketchData();
  let nowJointC = store.state.rlEntData.totalEntityData["rlJointC"];
  // console.log("allMainModelData", allMainModelData);
  let allJoint = allMainModelData.rlJoint;
  let allGrid = allMainModelData.rlGrid;
  let allJointC = [];
  let allGridC = [];
  for (let i = 0; i < allJoint.length; i++) {
    if (nowJointC.find((item) => item.Guid === allJoint[i].Guid)) {
      let nowJoint = getEntityData({
        classTypeName: "rlJointC",
        Guid: allJoint[i].Guid,
      });
      nowJoint.saveEditRevokeData();
      nowJoint.m_pt = allJoint[i].m_pt;
      nowJoint.updateThisObj(nowJoint);
      allJointC.push(nowJoint);
    } else {
      let joint = allJoint[i];
      let newJoint = new rlJointCData();
      newJoint.initData({
        m_pt: joint.m_pt,
        Guid: joint.Guid,
      });
      await addEntityToDrawing(newJoint, false);
      allJointC.push(newJoint);
    }
  }
  await saveDatabaseStore();
  let nowGridC = store.state.rlEntData.totalEntityData["rlGridC"];
  for (let i = 0; i < allGrid.length; i++) {
    if (nowGridC.find((item) => item.Guid === allGrid[i].Guid)) {
      let nowGrid = getEntityData({
        classTypeName: "rlGridC",
        Guid: allGrid[i].Guid,
      });
      let pt1 = new McGePoint3d(...allGrid[i].m_stJoint.m_pt);
      let pt2 = new McGePoint3d(...allGrid[i].m_edJoint.m_pt);
      let length = pt1.distanceTo(pt2);
      nowGrid.saveEditRevokeData();
      nowGrid.Length = Number(length.toFixed(0));
      nowGrid.updateThisObj(nowGrid);
      allGridC.push(nowGrid);
      continue;
    } else {
      let grid = allGrid[i];
      let newStJoint = allJointC.find(
        (item) => item.Guid === grid.m_stJoint.Guid
      );
      let newEdJoint = allJointC.find(
        (item) => item.Guid === grid.m_edJoint.Guid
      );
      if (!newStJoint || !newEdJoint) continue;
      let newStPt = new McGePoint3d(...newStJoint.m_pt);
      let newEdPt = new McGePoint3d(...newEdJoint.m_pt);
      let length = newStPt.distanceTo(newEdPt);
      let newGrid = new rlGridCData();
      newGrid.initData({
        Length: Number(length.toFixed(0)),
        m_stJoint: newStJoint,
        m_edJoint: newEdJoint,
        Guid: grid.Guid,
        m_Axis: null,
      });
      let isExist = await addEntityToDrawing(newGrid, false);
      if (isExist) {
        isExist.saveEditRevokeData();
        isExist.Length = Number(length.toFixed(0));
        isExist.updateThisObj(isExist);
        allGridC.push(isExist);
      } else {
        allGridC.push(newGrid);
      }
    }
  }
  //更新显示
  rlAppObj.rlMxDrawObject.updateDisplay();
  await saveDatabaseStore();
  let rl_floor_arr = store.state.globalData.rl_floor_arr;
  let rl_stdFlr_id = store.state.globalData.rl_stdFlr_id;
  const floorId = rl_floor_arr.find((item) => item.StdFlrGuid === rl_stdFlr_id);
  await changeFloorSrdC(floorId);
  await clearGridLength();
  return;
};

//把从正图导入进来的网格进行长度分类,减少网格长度显示的数量
export const clearGridLength = async () => {
  let allGridCTmp = store.state.rlEntData.totalEntityData["rlGridC"];
  let points = [];
  //获取所有草图网格的点
  allGridCTmp.forEach((item) => {
    points.push(new McGePoint3d(...item.m_stJoint.m_pt));
    points.push(new McGePoint3d(...item.m_edJoint.m_pt));
  });
  const leftBottomPoint = getLeftBottomPoint(points);

  //以最下角的点为原点,绘制XY轴,左右长度为100000
  const vecX1 = new THREE.Vector3(1, 0, 0);
  const vecX2 = new THREE.Vector3(-1, 0, 0);
  const vecY1 = new THREE.Vector3(0, 1, 0);
  const vecY2 = new THREE.Vector3(0, -1, 0);
  const lineX = new McDbLine();
  lineX.startPoint = MovePt(leftBottomPoint, vecX1, 10000000);
  lineX.endPoint = MovePt(leftBottomPoint, vecX2, 10000000);
  const lineY = new McDbLine();
  lineY.startPoint = MovePt(leftBottomPoint, vecY1, 10000000);
  lineY.endPoint = MovePt(leftBottomPoint, vecY2, 10000000);
  let gridCDistGroup = [];
  let indexMark = 0; //索引标记
  allGridCTmp.forEach((item) => {
    let stPt = new McGePoint3d(...item.m_stJoint.m_pt);
    let edPt = new McGePoint3d(...item.m_edJoint.m_pt);
    let modelNum = item.Length;
    if (store.state.inspectionStore.isRoundSketch)
      modelNum = ret50Modulus(item.Length);
    let totalData = modelNum;
    if (store.state.inspectionStore.isAddWallThicknessSketch && modelNum != 0)
      totalData = modelNum + item.Thickness;
    if (isParallel(lineX.startPoint, lineX.endPoint, stPt, edPt)) {
      //把点投影到X轴上
      let closeStPt = lineX.getClosestPointTo(stPt).val;
      let closeEdPt = lineX.getClosestPointTo(edPt).val;
      let index = gridCDistGroup.findIndex(
        (item) =>
          (isPointEqual(closeStPt, item.stPt, 0.1) ||
            isPointEqual(closeStPt, item.edPt, 0.1)) &&
          (isPointEqual(closeEdPt, item.stPt, 0.1) ||
            isPointEqual(closeEdPt, item.edPt, 0.1))
      );
      if (index === -1) {
        gridCDistGroup.push({
          index: indexMark++,
          stPt: closeStPt,
          edPt: closeEdPt,
          length: totalData,
          gridC: [item],
          childGroup: [],
          mainGroup: [],
          isOblique: true, //是否正交
        });
      } else {
        gridCDistGroup[index].gridC.push(item);
        if (gridCDistGroup[index].length == 0) {
          gridCDistGroup[index].length = totalData;
        }
      }
    } else if (isParallel(lineY.startPoint, lineY.endPoint, stPt, edPt)) {
      //把点投影到Y轴上
      let closeStPt = lineY.getClosestPointTo(stPt).val;
      let closeEdPt = lineY.getClosestPointTo(edPt).val;
      let index = gridCDistGroup.findIndex(
        (item) =>
          (isPointEqual(closeStPt, item.stPt, 0.1) ||
            isPointEqual(closeStPt, item.edPt, 0.1)) &&
          (isPointEqual(closeEdPt, item.stPt, 0.1) ||
            isPointEqual(closeEdPt, item.edPt, 0.1))
      );
      if (index === -1) {
        gridCDistGroup.push({
          index: indexMark++,
          stPt: closeStPt,
          edPt: closeEdPt,
          length: totalData,
          gridC: [item],
          childGroup: [],
          mainGroup: [],
          isOblique: true, //是否正交
        });
      } else {
        gridCDistGroup[index].gridC.push(item);
        if (gridCDistGroup[index].length == 0) {
          gridCDistGroup[index].length = totalData;
        }
      }
    } else {
      let index = gridCDistGroup.findIndex(
        (item) =>
          (isPointEqual(stPt, item.stPt, 0.1) ||
            isPointEqual(stPt, item.edPt, 0.1)) &&
          (isPointEqual(edPt, item.stPt, 0.1) ||
            isPointEqual(edPt, item.edPt, 0.1))
      );
      if (index === -1) {
        gridCDistGroup.push({
          index: indexMark++,
          stPt: stPt,
          edPt: edPt,
          length: totalData,
          gridC: [item],
          childGroup: [],
          mainGroup: [],
          isOblique: false, //是否正交
        });
      } else {
        gridCDistGroup[index].gridC.push(item);
        if (gridCDistGroup[index].length == 0) {
          gridCDistGroup[index].length = totalData;
        }
      }
    }
  });
  for (let i = 0; i < gridCDistGroup.length; i++) {
    let group = gridCDistGroup[i];
    let isParallelY = isParallel(
      group.stPt,
      group.edPt,
      new McGePoint3d(0, 0, 0),
      new McGePoint3d(0, 1, 0)
    );
    let isParallelX = isParallel(
      group.stPt,
      group.edPt,
      new McGePoint3d(0, 0, 0),
      new McGePoint3d(1, 0, 0)
    );
    if (!isParallelY && !isParallelX) continue;
    let gridGuid = "";
    let minX = 9999999999999;
    let minY = 9999999999999;
    for (let j = 0; j < group.gridC.length; j++) {
      //排序找到最左边的网格
      if (isParallelY) {
        let x = group.gridC[j].m_stJoint.m_pt[0];
        if (x < minX) {
          minX = x;
          gridGuid = group.gridC[j].Guid;
        }
      } else if (isParallelX) {
        let y = group.gridC[j].m_stJoint.m_pt[1];
        if (y < minY) {
          minY = y;
          gridGuid = group.gridC[j].Guid;
        }
      }
    }
    if (gridGuid == "") continue;
    //除了最左边的网格或者最下边的网格，其他网格的长度都设置为0
    for (let j = 0; j < group.gridC.length; j++) {
      if (group.gridC[j].Guid == gridGuid) continue;
      let grid = getEntityData({
        classTypeName: "rlGridC",
        Guid: group.gridC[j].Guid,
      });
      grid.saveEditRevokeData();
      grid.Length = 0;
      grid.updateThisObj(grid);
    }
  }
  await saveDatabaseStore();
  //更新显示
  rlAppObj.rlMxDrawObject.updateDisplay();
  return;
};
